/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function ct(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const o of e.split(",")) t[o] = 1;
  return (o) => o in t;
}
const J = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, jt = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], fe = () => {
}, Xn = () => !1, ao = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), So = (e) => e.startsWith("onUpdate:"), ne = Object.assign, Ds = (e, t) => {
  const o = e.indexOf(t);
  o > -1 && e.splice(o, 1);
}, Qn = Object.prototype.hasOwnProperty, B = (e, t) => Qn.call(e, t), k = Array.isArray, Dt = (e) => Ho(e) === "[object Map]", Tr = (e) => Ho(e) === "[object Set]", $ = (e) => typeof e == "function", re = (e) => typeof e == "string", at = (e) => typeof e == "symbol", Q = (e) => e !== null && typeof e == "object", Vs = (e) => (Q(e) || $(e)) && $(e.then) && $(e.catch), Ar = Object.prototype.toString, Ho = (e) => Ar.call(e), Ss = (e) => Ho(e).slice(8, -1), Lo = (e) => Ho(e) === "[object Object]", Cs = (e) => re(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, eo = /* @__PURE__ */ ct(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Zn = /* @__PURE__ */ ct(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), Uo = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (o) => t[o] || (t[o] = e(o));
}, ei = /-(\w)/g, Se = Uo(
  (e) => e.replace(ei, (t, o) => o ? o.toUpperCase() : "")
), ti = /\B([A-Z])/g, $e = Uo(
  (e) => e.replace(ti, "-$1").toLowerCase()
), Bo = Uo((e) => e.charAt(0).toUpperCase() + e.slice(1)), Nt = Uo(
  (e) => e ? `on${Bo(e)}` : ""
), yt = (e, t) => !Object.is(e, t), Kt = (e, ...t) => {
  for (let o = 0; o < e.length; o++)
    e[o](...t);
}, Co = (e, t, o, s = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: s,
    value: o
  });
}, oi = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, qs = (e) => {
  const t = re(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let Gs;
const uo = () => Gs || (Gs = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function _e(e) {
  if (k(e)) {
    const t = {};
    for (let o = 0; o < e.length; o++) {
      const s = e[o], r = re(s) ? ii(s) : _e(s);
      if (r)
        for (const n in r)
          t[n] = r[n];
    }
    return t;
  } else if (re(e) || Q(e))
    return e;
}
const si = /;(?![^(]*\))/g, ri = /:([^]+)/, ni = /\/\*[^]*?\*\//g;
function ii(e) {
  const t = {};
  return e.replace(ni, "").split(si).forEach((o) => {
    if (o) {
      const s = o.split(ri);
      s.length > 1 && (t[s[0].trim()] = s[1].trim());
    }
  }), t;
}
function vt(e) {
  let t = "";
  if (re(e))
    t = e;
  else if (k(e))
    for (let o = 0; o < e.length; o++) {
      const s = vt(e[o]);
      s && (t += s + " ");
    }
  else if (Q(e))
    for (const o in e)
      e[o] && (t += o + " ");
  return t.trim();
}
const li = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", ci = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", ai = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", ui = /* @__PURE__ */ ct(li), fi = /* @__PURE__ */ ct(ci), di = /* @__PURE__ */ ct(ai), pi = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", hi = /* @__PURE__ */ ct(pi);
function Ir(e) {
  return !!e || e === "";
}
const kr = (e) => !!(e && e.__v_isRef === !0), ce = (e) => re(e) ? e : e == null ? "" : k(e) || Q(e) && (e.toString === Ar || !$(e.toString)) ? kr(e) ? ce(e.value) : JSON.stringify(e, Pr, 2) : String(e), Pr = (e, t) => kr(t) ? Pr(e, t.value) : Dt(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (o, [s, r], n) => (o[es(s, n) + " =>"] = r, o),
    {}
  )
} : Tr(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((o) => es(o))
} : at(t) ? es(t) : Q(t) && !k(t) && !Lo(t) ? String(t) : t, es = (e, t = "") => {
  var o;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    at(e) ? `Symbol(${(o = e.description) != null ? o : t})` : e
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function ot(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let Pe;
class gi {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Pe, !t && Pe && (this.index = (Pe.scopes || (Pe.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, o;
      if (this.scopes)
        for (t = 0, o = this.scopes.length; t < o; t++)
          this.scopes[t].pause();
      for (t = 0, o = this.effects.length; t < o; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, o;
      if (this.scopes)
        for (t = 0, o = this.scopes.length; t < o; t++)
          this.scopes[t].resume();
      for (t = 0, o = this.effects.length; t < o; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const o = Pe;
      try {
        return Pe = this, t();
      } finally {
        Pe = o;
      }
    } else process.env.NODE_ENV !== "production" && ot("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    Pe = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    Pe = this.parent;
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let o, s;
      for (o = 0, s = this.effects.length; o < s; o++)
        this.effects[o].stop();
      for (this.effects.length = 0, o = 0, s = this.cleanups.length; o < s; o++)
        this.cleanups[o]();
      if (this.cleanups.length = 0, this.scopes) {
        for (o = 0, s = this.scopes.length; o < s; o++)
          this.scopes[o].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const r = this.parent.scopes.pop();
        r && r !== this && (this.parent.scopes[this.index] = r, r.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function mi() {
  return Pe;
}
let G;
const ts = /* @__PURE__ */ new WeakSet();
class $r {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Pe && Pe.active && Pe.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, ts.has(this) && (ts.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Rr(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Js(this), jr(this);
    const t = G, o = We;
    G = this, We = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && G !== this && ot(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), Fr(this), G = t, We = o, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Is(t);
      this.deps = this.depsTail = void 0, Js(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? ts.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    us(this) && this.run();
  }
  get dirty() {
    return us(this);
  }
}
let Mr = 0, to, oo;
function Rr(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = oo, oo = e;
    return;
  }
  e.next = to, to = e;
}
function Ts() {
  Mr++;
}
function As() {
  if (--Mr > 0)
    return;
  if (oo) {
    let t = oo;
    for (oo = void 0; t; ) {
      const o = t.next;
      t.next = void 0, t.flags &= -9, t = o;
    }
  }
  let e;
  for (; to; ) {
    let t = to;
    for (to = void 0; t; ) {
      const o = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (s) {
          e || (e = s);
        }
      t = o;
    }
  }
  if (e) throw e;
}
function jr(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Fr(e) {
  let t, o = e.depsTail, s = o;
  for (; s; ) {
    const r = s.prevDep;
    s.version === -1 ? (s === o && (o = r), Is(s), bi(s)) : t = s, s.dep.activeLink = s.prevActiveLink, s.prevActiveLink = void 0, s = r;
  }
  e.deps = t, e.depsTail = o;
}
function us(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (zr(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function zr(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === ro))
    return;
  e.globalVersion = ro;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !us(e)) {
    e.flags &= -3;
    return;
  }
  const o = G, s = We;
  G = e, We = !0;
  try {
    jr(e);
    const r = e.fn(e._value);
    (t.version === 0 || yt(r, e._value)) && (e._value = r, t.version++);
  } catch (r) {
    throw t.version++, r;
  } finally {
    G = o, We = s, Fr(e), e.flags &= -3;
  }
}
function Is(e, t = !1) {
  const { dep: o, prevSub: s, nextSub: r } = e;
  if (s && (s.nextSub = r, e.prevSub = void 0), r && (r.prevSub = s, e.nextSub = void 0), process.env.NODE_ENV !== "production" && o.subsHead === e && (o.subsHead = r), o.subs === e && (o.subs = s, !s && o.computed)) {
    o.computed.flags &= -5;
    for (let n = o.computed.deps; n; n = n.nextDep)
      Is(n, !0);
  }
  !t && !--o.sc && o.map && o.map.delete(o.key);
}
function bi(e) {
  const { prevDep: t, nextDep: o } = e;
  t && (t.nextDep = o, e.prevDep = void 0), o && (o.prevDep = t, e.nextDep = void 0);
}
let We = !0;
const Hr = [];
function ut() {
  Hr.push(We), We = !1;
}
function ft() {
  const e = Hr.pop();
  We = e === void 0 ? !0 : e;
}
function Js(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const o = G;
    G = void 0;
    try {
      t();
    } finally {
      G = o;
    }
  }
}
let ro = 0;
class vi {
  constructor(t, o) {
    this.sub = t, this.dep = o, this.version = o.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class ks {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!G || !We || G === this.computed)
      return;
    let o = this.activeLink;
    if (o === void 0 || o.sub !== G)
      o = this.activeLink = new vi(G, this), G.deps ? (o.prevDep = G.depsTail, G.depsTail.nextDep = o, G.depsTail = o) : G.deps = G.depsTail = o, Lr(o);
    else if (o.version === -1 && (o.version = this.version, o.nextDep)) {
      const s = o.nextDep;
      s.prevDep = o.prevDep, o.prevDep && (o.prevDep.nextDep = s), o.prevDep = G.depsTail, o.nextDep = void 0, G.depsTail.nextDep = o, G.depsTail = o, G.deps === o && (G.deps = s);
    }
    return process.env.NODE_ENV !== "production" && G.onTrack && G.onTrack(
      ne(
        {
          effect: G
        },
        t
      )
    ), o;
  }
  trigger(t) {
    this.version++, ro++, this.notify(t);
  }
  notify(t) {
    Ts();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let o = this.subsHead; o; o = o.nextSub)
          o.sub.onTrigger && !(o.sub.flags & 8) && o.sub.onTrigger(
            ne(
              {
                effect: o.sub
              },
              t
            )
          );
      for (let o = this.subs; o; o = o.prevSub)
        o.sub.notify() && o.sub.dep.notify();
    } finally {
      As();
    }
  }
}
function Lr(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let s = t.deps; s; s = s.nextDep)
        Lr(s);
    }
    const o = e.dep.subs;
    o !== e && (e.prevSub = o, o && (o.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const fs = /* @__PURE__ */ new WeakMap(), Vt = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), ds = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), no = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function ue(e, t, o) {
  if (We && G) {
    let s = fs.get(e);
    s || fs.set(e, s = /* @__PURE__ */ new Map());
    let r = s.get(o);
    r || (s.set(o, r = new ks()), r.map = s, r.key = o), process.env.NODE_ENV !== "production" ? r.track({
      target: e,
      type: t,
      key: o
    }) : r.track();
  }
}
function Ze(e, t, o, s, r, n) {
  const i = fs.get(e);
  if (!i) {
    ro++;
    return;
  }
  const l = (a) => {
    a && (process.env.NODE_ENV !== "production" ? a.trigger({
      target: e,
      type: t,
      key: o,
      newValue: s,
      oldValue: r,
      oldTarget: n
    }) : a.trigger());
  };
  if (Ts(), t === "clear")
    i.forEach(l);
  else {
    const a = k(e), p = a && Cs(o);
    if (a && o === "length") {
      const d = Number(s);
      i.forEach((f, m) => {
        (m === "length" || m === no || !at(m) && m >= d) && l(f);
      });
    } else
      switch ((o !== void 0 || i.has(void 0)) && l(i.get(o)), p && l(i.get(no)), t) {
        case "add":
          a ? p && l(i.get("length")) : (l(i.get(Vt)), Dt(e) && l(i.get(ds)));
          break;
        case "delete":
          a || (l(i.get(Vt)), Dt(e) && l(i.get(ds)));
          break;
        case "set":
          Dt(e) && l(i.get(Vt));
          break;
      }
  }
  As();
}
function kt(e) {
  const t = F(e);
  return t === e ? t : (ue(t, "iterate", no), Oe(e) ? t : t.map(ye));
}
function Wo(e) {
  return ue(e = F(e), "iterate", no), e;
}
const _i = {
  __proto__: null,
  [Symbol.iterator]() {
    return os(this, Symbol.iterator, ye);
  },
  concat(...e) {
    return kt(this).concat(
      ...e.map((t) => k(t) ? kt(t) : t)
    );
  },
  entries() {
    return os(this, "entries", (e) => (e[1] = ye(e[1]), e));
  },
  every(e, t) {
    return rt(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return rt(this, "filter", e, t, (o) => o.map(ye), arguments);
  },
  find(e, t) {
    return rt(this, "find", e, t, ye, arguments);
  },
  findIndex(e, t) {
    return rt(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return rt(this, "findLast", e, t, ye, arguments);
  },
  findLastIndex(e, t) {
    return rt(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return rt(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return ss(this, "includes", e);
  },
  indexOf(...e) {
    return ss(this, "indexOf", e);
  },
  join(e) {
    return kt(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return ss(this, "lastIndexOf", e);
  },
  map(e, t) {
    return rt(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return qt(this, "pop");
  },
  push(...e) {
    return qt(this, "push", e);
  },
  reduce(e, ...t) {
    return Ys(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Ys(this, "reduceRight", e, t);
  },
  shift() {
    return qt(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return rt(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return qt(this, "splice", e);
  },
  toReversed() {
    return kt(this).toReversed();
  },
  toSorted(e) {
    return kt(this).toSorted(e);
  },
  toSpliced(...e) {
    return kt(this).toSpliced(...e);
  },
  unshift(...e) {
    return qt(this, "unshift", e);
  },
  values() {
    return os(this, "values", ye);
  }
};
function os(e, t, o) {
  const s = Wo(e), r = s[t]();
  return s !== e && !Oe(e) && (r._next = r.next, r.next = () => {
    const n = r._next();
    return n.value && (n.value = o(n.value)), n;
  }), r;
}
const yi = Array.prototype;
function rt(e, t, o, s, r, n) {
  const i = Wo(e), l = i !== e && !Oe(e), a = i[t];
  if (a !== yi[t]) {
    const f = a.apply(e, n);
    return l ? ye(f) : f;
  }
  let p = o;
  i !== e && (l ? p = function(f, m) {
    return o.call(this, ye(f), m, e);
  } : o.length > 2 && (p = function(f, m) {
    return o.call(this, f, m, e);
  }));
  const d = a.call(i, p, s);
  return l && r ? r(d) : d;
}
function Ys(e, t, o, s) {
  const r = Wo(e);
  let n = o;
  return r !== e && (Oe(e) ? o.length > 3 && (n = function(i, l, a) {
    return o.call(this, i, l, a, e);
  }) : n = function(i, l, a) {
    return o.call(this, i, ye(l), a, e);
  }), r[t](n, ...s);
}
function ss(e, t, o) {
  const s = F(e);
  ue(s, "iterate", no);
  const r = s[t](...o);
  return (r === -1 || r === !1) && To(o[0]) ? (o[0] = F(o[0]), s[t](...o)) : r;
}
function qt(e, t, o = []) {
  ut(), Ts();
  const s = F(e)[t].apply(e, o);
  return As(), ft(), s;
}
const wi = /* @__PURE__ */ ct("__proto__,__v_isRef,__isVue"), Ur = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(at)
);
function Ei(e) {
  at(e) || (e = String(e));
  const t = F(this);
  return ue(t, "has", e), t.hasOwnProperty(e);
}
class Br {
  constructor(t = !1, o = !1) {
    this._isReadonly = t, this._isShallow = o;
  }
  get(t, o, s) {
    if (o === "__v_skip") return t.__v_skip;
    const r = this._isReadonly, n = this._isShallow;
    if (o === "__v_isReactive")
      return !r;
    if (o === "__v_isReadonly")
      return r;
    if (o === "__v_isShallow")
      return n;
    if (o === "__v_raw")
      return s === (r ? n ? Yr : Jr : n ? Gr : qr).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(s) ? t : void 0;
    const i = k(t);
    if (!r) {
      let a;
      if (i && (a = _i[o]))
        return a;
      if (o === "hasOwnProperty")
        return Ei;
    }
    const l = Reflect.get(
      t,
      o,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      ae(t) ? t : s
    );
    return (at(o) ? Ur.has(o) : wi(o)) || (r || ue(t, "get", o), n) ? l : ae(l) ? i && Cs(o) ? l : l.value : Q(l) ? r ? Xr(l) : qo(l) : l;
  }
}
class Wr extends Br {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, o, s, r) {
    let n = t[o];
    if (!this._isShallow) {
      const a = lt(n);
      if (!Oe(s) && !lt(s) && (n = F(n), s = F(s)), !k(t) && ae(n) && !ae(s))
        return a ? !1 : (n.value = s, !0);
    }
    const i = k(t) && Cs(o) ? Number(o) < t.length : B(t, o), l = Reflect.set(
      t,
      o,
      s,
      ae(t) ? t : r
    );
    return t === F(r) && (i ? yt(s, n) && Ze(t, "set", o, s, n) : Ze(t, "add", o, s)), l;
  }
  deleteProperty(t, o) {
    const s = B(t, o), r = t[o], n = Reflect.deleteProperty(t, o);
    return n && s && Ze(t, "delete", o, void 0, r), n;
  }
  has(t, o) {
    const s = Reflect.has(t, o);
    return (!at(o) || !Ur.has(o)) && ue(t, "has", o), s;
  }
  ownKeys(t) {
    return ue(
      t,
      "iterate",
      k(t) ? "length" : Vt
    ), Reflect.ownKeys(t);
  }
}
class Kr extends Br {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, o) {
    return process.env.NODE_ENV !== "production" && ot(
      `Set operation on key "${String(o)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, o) {
    return process.env.NODE_ENV !== "production" && ot(
      `Delete operation on key "${String(o)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const xi = /* @__PURE__ */ new Wr(), Ni = /* @__PURE__ */ new Kr(), Oi = /* @__PURE__ */ new Wr(!0), Di = /* @__PURE__ */ new Kr(!0), ps = (e) => e, bo = (e) => Reflect.getPrototypeOf(e);
function Vi(e, t, o) {
  return function(...s) {
    const r = this.__v_raw, n = F(r), i = Dt(n), l = e === "entries" || e === Symbol.iterator && i, a = e === "keys" && i, p = r[e](...s), d = o ? ps : t ? hs : ye;
    return !t && ue(
      n,
      "iterate",
      a ? ds : Vt
    ), {
      // iterator protocol
      next() {
        const { value: f, done: m } = p.next();
        return m ? { value: f, done: m } : {
          value: l ? [d(f[0]), d(f[1])] : d(f),
          done: m
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function vo(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const o = t[0] ? `on key "${t[0]}" ` : "";
      ot(
        `${Bo(e)} operation ${o}failed: target is readonly.`,
        F(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function Si(e, t) {
  const o = {
    get(r) {
      const n = this.__v_raw, i = F(n), l = F(r);
      e || (yt(r, l) && ue(i, "get", r), ue(i, "get", l));
      const { has: a } = bo(i), p = t ? ps : e ? hs : ye;
      if (a.call(i, r))
        return p(n.get(r));
      if (a.call(i, l))
        return p(n.get(l));
      n !== i && n.get(r);
    },
    get size() {
      const r = this.__v_raw;
      return !e && ue(F(r), "iterate", Vt), Reflect.get(r, "size", r);
    },
    has(r) {
      const n = this.__v_raw, i = F(n), l = F(r);
      return e || (yt(r, l) && ue(i, "has", r), ue(i, "has", l)), r === l ? n.has(r) : n.has(r) || n.has(l);
    },
    forEach(r, n) {
      const i = this, l = i.__v_raw, a = F(l), p = t ? ps : e ? hs : ye;
      return !e && ue(a, "iterate", Vt), l.forEach((d, f) => r.call(n, p(d), p(f), i));
    }
  };
  return ne(
    o,
    e ? {
      add: vo("add"),
      set: vo("set"),
      delete: vo("delete"),
      clear: vo("clear")
    } : {
      add(r) {
        !t && !Oe(r) && !lt(r) && (r = F(r));
        const n = F(this);
        return bo(n).has.call(n, r) || (n.add(r), Ze(n, "add", r, r)), this;
      },
      set(r, n) {
        !t && !Oe(n) && !lt(n) && (n = F(n));
        const i = F(this), { has: l, get: a } = bo(i);
        let p = l.call(i, r);
        p ? process.env.NODE_ENV !== "production" && Xs(i, l, r) : (r = F(r), p = l.call(i, r));
        const d = a.call(i, r);
        return i.set(r, n), p ? yt(n, d) && Ze(i, "set", r, n, d) : Ze(i, "add", r, n), this;
      },
      delete(r) {
        const n = F(this), { has: i, get: l } = bo(n);
        let a = i.call(n, r);
        a ? process.env.NODE_ENV !== "production" && Xs(n, i, r) : (r = F(r), a = i.call(n, r));
        const p = l ? l.call(n, r) : void 0, d = n.delete(r);
        return a && Ze(n, "delete", r, void 0, p), d;
      },
      clear() {
        const r = F(this), n = r.size !== 0, i = process.env.NODE_ENV !== "production" ? Dt(r) ? new Map(r) : new Set(r) : void 0, l = r.clear();
        return n && Ze(
          r,
          "clear",
          void 0,
          void 0,
          i
        ), l;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((r) => {
    o[r] = Vi(r, e, t);
  }), o;
}
function Ko(e, t) {
  const o = Si(e, t);
  return (s, r, n) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? s : Reflect.get(
    B(o, r) && r in s ? o : s,
    r,
    n
  );
}
const Ci = {
  get: /* @__PURE__ */ Ko(!1, !1)
}, Ti = {
  get: /* @__PURE__ */ Ko(!1, !0)
}, Ai = {
  get: /* @__PURE__ */ Ko(!0, !1)
}, Ii = {
  get: /* @__PURE__ */ Ko(!0, !0)
};
function Xs(e, t, o) {
  const s = F(o);
  if (s !== o && t.call(e, s)) {
    const r = Ss(e);
    ot(
      `Reactive ${r} contains both the raw and reactive versions of the same object${r === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const qr = /* @__PURE__ */ new WeakMap(), Gr = /* @__PURE__ */ new WeakMap(), Jr = /* @__PURE__ */ new WeakMap(), Yr = /* @__PURE__ */ new WeakMap();
function ki(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Pi(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : ki(Ss(e));
}
function qo(e) {
  return lt(e) ? e : Go(
    e,
    !1,
    xi,
    Ci,
    qr
  );
}
function $i(e) {
  return Go(
    e,
    !1,
    Oi,
    Ti,
    Gr
  );
}
function Xr(e) {
  return Go(
    e,
    !0,
    Ni,
    Ai,
    Jr
  );
}
function et(e) {
  return Go(
    e,
    !0,
    Di,
    Ii,
    Yr
  );
}
function Go(e, t, o, s, r) {
  if (!Q(e))
    return process.env.NODE_ENV !== "production" && ot(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const n = r.get(e);
  if (n)
    return n;
  const i = Pi(e);
  if (i === 0)
    return e;
  const l = new Proxy(
    e,
    i === 2 ? s : o
  );
  return r.set(e, l), l;
}
function St(e) {
  return lt(e) ? St(e.__v_raw) : !!(e && e.__v_isReactive);
}
function lt(e) {
  return !!(e && e.__v_isReadonly);
}
function Oe(e) {
  return !!(e && e.__v_isShallow);
}
function To(e) {
  return e ? !!e.__v_raw : !1;
}
function F(e) {
  const t = e && e.__v_raw;
  return t ? F(t) : e;
}
function Mi(e) {
  return !B(e, "__v_skip") && Object.isExtensible(e) && Co(e, "__v_skip", !0), e;
}
const ye = (e) => Q(e) ? qo(e) : e, hs = (e) => Q(e) ? Xr(e) : e;
function ae(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function Pt(e) {
  return Ri(e, !1);
}
function Ri(e, t) {
  return ae(e) ? e : new ji(e, t);
}
class ji {
  constructor(t, o) {
    this.dep = new ks(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = o ? t : F(t), this._value = o ? t : ye(t), this.__v_isShallow = o;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const o = this._rawValue, s = this.__v_isShallow || Oe(t) || lt(t);
    t = s ? t : F(t), yt(t, o) && (this._rawValue = t, this._value = s ? t : ye(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: o
    }) : this.dep.trigger());
  }
}
function Qr(e) {
  return ae(e) ? e.value : e;
}
const Fi = {
  get: (e, t, o) => t === "__v_raw" ? e : Qr(Reflect.get(e, t, o)),
  set: (e, t, o, s) => {
    const r = e[t];
    return ae(r) && !ae(o) ? (r.value = o, !0) : Reflect.set(e, t, o, s);
  }
};
function Zr(e) {
  return St(e) ? e : new Proxy(e, Fi);
}
class zi {
  constructor(t, o, s) {
    this.fn = t, this.setter = o, this._value = void 0, this.dep = new ks(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = ro - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !o, this.isSSR = s;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    G !== this)
      return Rr(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return zr(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && ot("Write operation failed: computed value is readonly");
  }
}
function Hi(e, t, o = !1) {
  let s, r;
  $(e) ? s = e : (s = e.get, r = e.set);
  const n = new zi(s, r, o);
  return process.env.NODE_ENV, n;
}
const _o = {}, Ao = /* @__PURE__ */ new WeakMap();
let Ot;
function Li(e, t = !1, o = Ot) {
  if (o) {
    let s = Ao.get(o);
    s || Ao.set(o, s = []), s.push(e);
  } else process.env.NODE_ENV !== "production" && !t && ot(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function Ui(e, t, o = J) {
  const { immediate: s, deep: r, once: n, scheduler: i, augmentJob: l, call: a } = o, p = (A) => {
    (o.onWarn || ot)(
      "Invalid watch source: ",
      A,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, d = (A) => r ? A : Oe(A) || r === !1 || r === 0 ? it(A, 1) : it(A);
  let f, m, V, E, j = !1, te = !1;
  if (ae(e) ? (m = () => e.value, j = Oe(e)) : St(e) ? (m = () => d(e), j = !0) : k(e) ? (te = !0, j = e.some((A) => St(A) || Oe(A)), m = () => e.map((A) => {
    if (ae(A))
      return A.value;
    if (St(A))
      return d(A);
    if ($(A))
      return a ? a(A, 2) : A();
    process.env.NODE_ENV !== "production" && p(A);
  })) : $(e) ? t ? m = a ? () => a(e, 2) : e : m = () => {
    if (V) {
      ut();
      try {
        V();
      } finally {
        ft();
      }
    }
    const A = Ot;
    Ot = f;
    try {
      return a ? a(e, 3, [E]) : e(E);
    } finally {
      Ot = A;
    }
  } : (m = fe, process.env.NODE_ENV !== "production" && p(e)), t && r) {
    const A = m, ie = r === !0 ? 1 / 0 : r;
    m = () => it(A(), ie);
  }
  const q = mi(), oe = () => {
    f.stop(), q && q.active && Ds(q.effects, f);
  };
  if (n && t) {
    const A = t;
    t = (...ie) => {
      A(...ie), oe();
    };
  }
  let W = te ? new Array(e.length).fill(_o) : _o;
  const be = (A) => {
    if (!(!(f.flags & 1) || !f.dirty && !A))
      if (t) {
        const ie = f.run();
        if (r || j || (te ? ie.some((De, pe) => yt(De, W[pe])) : yt(ie, W))) {
          V && V();
          const De = Ot;
          Ot = f;
          try {
            const pe = [
              ie,
              // pass undefined as the old value when it's changed for the first time
              W === _o ? void 0 : te && W[0] === _o ? [] : W,
              E
            ];
            a ? a(t, 3, pe) : (
              // @ts-expect-error
              t(...pe)
            ), W = ie;
          } finally {
            Ot = De;
          }
        }
      } else
        f.run();
  };
  return l && l(be), f = new $r(m), f.scheduler = i ? () => i(be, !1) : be, E = (A) => Li(A, !1, f), V = f.onStop = () => {
    const A = Ao.get(f);
    if (A) {
      if (a)
        a(A, 4);
      else
        for (const ie of A) ie();
      Ao.delete(f);
    }
  }, process.env.NODE_ENV !== "production" && (f.onTrack = o.onTrack, f.onTrigger = o.onTrigger), t ? s ? be(!0) : W = f.run() : i ? i(be.bind(null, !0), !0) : f.run(), oe.pause = f.pause.bind(f), oe.resume = f.resume.bind(f), oe.stop = oe, oe;
}
function it(e, t = 1 / 0, o) {
  if (t <= 0 || !Q(e) || e.__v_skip || (o = o || /* @__PURE__ */ new Set(), o.has(e)))
    return e;
  if (o.add(e), t--, ae(e))
    it(e.value, t, o);
  else if (k(e))
    for (let s = 0; s < e.length; s++)
      it(e[s], t, o);
  else if (Tr(e) || Dt(e))
    e.forEach((s) => {
      it(s, t, o);
    });
  else if (Lo(e)) {
    for (const s in e)
      it(e[s], t, o);
    for (const s of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, s) && it(e[s], t, o);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Ct = [];
function yo(e) {
  Ct.push(e);
}
function wo() {
  Ct.pop();
}
let rs = !1;
function D(e, ...t) {
  if (rs) return;
  rs = !0, ut();
  const o = Ct.length ? Ct[Ct.length - 1].component : null, s = o && o.appContext.config.warnHandler, r = Bi();
  if (s)
    Ut(
      s,
      o,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((n) => {
          var i, l;
          return (l = (i = n.toString) == null ? void 0 : i.call(n)) != null ? l : JSON.stringify(n);
        }).join(""),
        o && o.proxy,
        r.map(
          ({ vnode: n }) => `at <${Zo(o, n.type)}>`
        ).join(`
`),
        r
      ]
    );
  else {
    const n = [`[Vue warn]: ${e}`, ...t];
    r.length && n.push(`
`, ...Wi(r)), console.warn(...n);
  }
  ft(), rs = !1;
}
function Bi() {
  let e = Ct[Ct.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const o = t[0];
    o && o.vnode === e ? o.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const s = e.component && e.component.parent;
    e = s && s.vnode;
  }
  return t;
}
function Wi(e) {
  const t = [];
  return e.forEach((o, s) => {
    t.push(...s === 0 ? [] : [`
`], ...Ki(o));
  }), t;
}
function Ki({ vnode: e, recurseCount: t }) {
  const o = t > 0 ? `... (${t} recursive calls)` : "", s = e.component ? e.component.parent == null : !1, r = ` at <${Zo(
    e.component,
    e.type,
    s
  )}`, n = ">" + o;
  return e.props ? [r, ...qi(e.props), n] : [r + n];
}
function qi(e) {
  const t = [], o = Object.keys(e);
  return o.slice(0, 3).forEach((s) => {
    t.push(...en(s, e[s]));
  }), o.length > 3 && t.push(" ..."), t;
}
function en(e, t, o) {
  return re(t) ? (t = JSON.stringify(t), o ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? o ? t : [`${e}=${t}`] : ae(t) ? (t = en(e, F(t.value), !0), o ? t : [`${e}=Ref<`, t, ">"]) : $(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = F(t), o ? t : [`${e}=`, t]);
}
const Ps = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function Ut(e, t, o, s) {
  try {
    return s ? e(...s) : e();
  } catch (r) {
    fo(r, t, o);
  }
}
function st(e, t, o, s) {
  if ($(e)) {
    const r = Ut(e, t, o, s);
    return r && Vs(r) && r.catch((n) => {
      fo(n, t, o);
    }), r;
  }
  if (k(e)) {
    const r = [];
    for (let n = 0; n < e.length; n++)
      r.push(st(e[n], t, o, s));
    return r;
  } else process.env.NODE_ENV !== "production" && D(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function fo(e, t, o, s = !0) {
  const r = t ? t.vnode : null, { errorHandler: n, throwUnhandledErrorInProduction: i } = t && t.appContext.config || J;
  if (t) {
    let l = t.parent;
    const a = t.proxy, p = process.env.NODE_ENV !== "production" ? Ps[o] : `https://vuejs.org/error-reference/#runtime-${o}`;
    for (; l; ) {
      const d = l.ec;
      if (d) {
        for (let f = 0; f < d.length; f++)
          if (d[f](e, a, p) === !1)
            return;
      }
      l = l.parent;
    }
    if (n) {
      ut(), Ut(n, null, 10, [
        e,
        a,
        p
      ]), ft();
      return;
    }
  }
  Gi(e, o, r, s, i);
}
function Gi(e, t, o, s = !0, r = !1) {
  if (process.env.NODE_ENV !== "production") {
    const n = Ps[t];
    if (o && yo(o), D(`Unhandled error${n ? ` during execution of ${n}` : ""}`), o && wo(), s)
      throw e;
    console.error(e);
  } else {
    if (r)
      throw e;
    console.error(e);
  }
}
const Ne = [];
let Qe = -1;
const Ft = [];
let mt = null, Rt = 0;
const tn = /* @__PURE__ */ Promise.resolve();
let Io = null;
const Ji = 100;
function on(e) {
  const t = Io || tn;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Yi(e) {
  let t = Qe + 1, o = Ne.length;
  for (; t < o; ) {
    const s = t + o >>> 1, r = Ne[s], n = io(r);
    n < e || n === e && r.flags & 2 ? t = s + 1 : o = s;
  }
  return t;
}
function Jo(e) {
  if (!(e.flags & 1)) {
    const t = io(e), o = Ne[Ne.length - 1];
    !o || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= io(o) ? Ne.push(e) : Ne.splice(Yi(t), 0, e), e.flags |= 1, sn();
  }
}
function sn() {
  Io || (Io = tn.then(ln));
}
function rn(e) {
  k(e) ? Ft.push(...e) : mt && e.id === -1 ? mt.splice(Rt + 1, 0, e) : e.flags & 1 || (Ft.push(e), e.flags |= 1), sn();
}
function Qs(e, t, o = Qe + 1) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); o < Ne.length; o++) {
    const s = Ne[o];
    if (s && s.flags & 2) {
      if (e && s.id !== e.uid || process.env.NODE_ENV !== "production" && $s(t, s))
        continue;
      Ne.splice(o, 1), o--, s.flags & 4 && (s.flags &= -2), s(), s.flags & 4 || (s.flags &= -2);
    }
  }
}
function nn(e) {
  if (Ft.length) {
    const t = [...new Set(Ft)].sort(
      (o, s) => io(o) - io(s)
    );
    if (Ft.length = 0, mt) {
      mt.push(...t);
      return;
    }
    for (mt = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Rt = 0; Rt < mt.length; Rt++) {
      const o = mt[Rt];
      process.env.NODE_ENV !== "production" && $s(e, o) || (o.flags & 4 && (o.flags &= -2), o.flags & 8 || o(), o.flags &= -2);
    }
    mt = null, Rt = 0;
  }
}
const io = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function ln(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (o) => $s(e, o) : fe;
  try {
    for (Qe = 0; Qe < Ne.length; Qe++) {
      const o = Ne[Qe];
      if (o && !(o.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(o))
          continue;
        o.flags & 4 && (o.flags &= -2), Ut(
          o,
          o.i,
          o.i ? 15 : 14
        ), o.flags & 4 || (o.flags &= -2);
      }
    }
  } finally {
    for (; Qe < Ne.length; Qe++) {
      const o = Ne[Qe];
      o && (o.flags &= -2);
    }
    Qe = -1, Ne.length = 0, nn(e), Io = null, (Ne.length || Ft.length) && ln(e);
  }
}
function $s(e, t) {
  const o = e.get(t) || 0;
  if (o > Ji) {
    const s = t.i, r = s && Wn(s.type);
    return fo(
      `Maximum recursive updates exceeded${r ? ` in component <${r}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, o + 1), !1;
}
let tt = !1;
const Eo = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (uo().__VUE_HMR_RUNTIME__ = {
  createRecord: ns(cn),
  rerender: ns(Zi),
  reload: ns(el)
});
const At = /* @__PURE__ */ new Map();
function Xi(e) {
  const t = e.type.__hmrId;
  let o = At.get(t);
  o || (cn(t, e.type), o = At.get(t)), o.instances.add(e);
}
function Qi(e) {
  At.get(e.type.__hmrId).instances.delete(e);
}
function cn(e, t) {
  return At.has(e) ? !1 : (At.set(e, {
    initialDef: ko(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function ko(e) {
  return Kn(e) ? e.__vccOpts : e;
}
function Zi(e, t) {
  const o = At.get(e);
  o && (o.initialDef.render = t, [...o.instances].forEach((s) => {
    t && (s.render = t, ko(s.type).render = t), s.renderCache = [], tt = !0, s.update(), tt = !1;
  }));
}
function el(e, t) {
  const o = At.get(e);
  if (!o) return;
  t = ko(t), Zs(o.initialDef, t);
  const s = [...o.instances];
  for (let r = 0; r < s.length; r++) {
    const n = s[r], i = ko(n.type);
    let l = Eo.get(i);
    l || (i !== o.initialDef && Zs(i, t), Eo.set(i, l = /* @__PURE__ */ new Set())), l.add(n), n.appContext.propsCache.delete(n.type), n.appContext.emitsCache.delete(n.type), n.appContext.optionsCache.delete(n.type), n.ceReload ? (l.add(n), n.ceReload(t.styles), l.delete(n)) : n.parent ? Jo(() => {
      tt = !0, n.parent.update(), tt = !1, l.delete(n);
    }) : n.appContext.reload ? n.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), n.root.ce && n !== n.root && n.root.ce._removeChildStyle(i);
  }
  rn(() => {
    Eo.clear();
  });
}
function Zs(e, t) {
  ne(e, t);
  for (const o in e)
    o !== "__file" && !(o in t) && delete e[o];
}
function ns(e) {
  return (t, o) => {
    try {
      return e(t, o);
    } catch (s) {
      console.error(s), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let Be, Qt = [], gs = !1;
function po(e, ...t) {
  Be ? Be.emit(e, ...t) : gs || Qt.push({ event: e, args: t });
}
function Ms(e, t) {
  var o, s;
  Be = e, Be ? (Be.enabled = !0, Qt.forEach(({ event: r, args: n }) => Be.emit(r, ...n)), Qt = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((s = (o = window.navigator) == null ? void 0 : o.userAgent) != null && s.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((n) => {
    Ms(n, t);
  }), setTimeout(() => {
    Be || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, gs = !0, Qt = []);
  }, 3e3)) : (gs = !0, Qt = []);
}
function tl(e, t) {
  po("app:init", e, t, {
    Fragment: le,
    Text: ho,
    Comment: Ce,
    Static: Oo
  });
}
function ol(e) {
  po("app:unmount", e);
}
const sl = /* @__PURE__ */ Rs(
  "component:added"
  /* COMPONENT_ADDED */
), an = /* @__PURE__ */ Rs(
  "component:updated"
  /* COMPONENT_UPDATED */
), rl = /* @__PURE__ */ Rs(
  "component:removed"
  /* COMPONENT_REMOVED */
), nl = (e) => {
  Be && typeof Be.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !Be.cleanupBuffer(e) && rl(e);
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Rs(e) {
  return (t) => {
    po(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const il = /* @__PURE__ */ un(
  "perf:start"
  /* PERFORMANCE_START */
), ll = /* @__PURE__ */ un(
  "perf:end"
  /* PERFORMANCE_END */
);
function un(e) {
  return (t, o, s) => {
    po(e, t.appContext.app, t.uid, t, o, s);
  };
}
function cl(e, t, o) {
  po(
    "component:emit",
    e.appContext.app,
    e,
    t,
    o
  );
}
let de = null, fn = null;
function Po(e) {
  const t = de;
  return de = e, fn = e && e.type.__scopeId || null, t;
}
function dn(e, t = de, o) {
  if (!t || e._n)
    return e;
  const s = (...r) => {
    s._d && fr(-1);
    const n = Po(t);
    let i;
    try {
      i = e(...r);
    } finally {
      Po(n), s._d && fr(1);
    }
    return process.env.NODE_ENV !== "production" && an(t), i;
  };
  return s._n = !0, s._c = !0, s._d = !0, s;
}
function pn(e) {
  Zn(e) && D("Do not use built-in directive ids as custom directive id: " + e);
}
function al(e, t) {
  if (de === null)
    return process.env.NODE_ENV !== "production" && D("withDirectives can only be used inside render functions."), e;
  const o = Qo(de), s = e.dirs || (e.dirs = []);
  for (let r = 0; r < t.length; r++) {
    let [n, i, l, a = J] = t[r];
    n && ($(n) && (n = {
      mounted: n,
      updated: n
    }), n.deep && it(i), s.push({
      dir: n,
      instance: o,
      value: i,
      oldValue: void 0,
      arg: l,
      modifiers: a
    }));
  }
  return e;
}
function Et(e, t, o, s) {
  const r = e.dirs, n = t && t.dirs;
  for (let i = 0; i < r.length; i++) {
    const l = r[i];
    n && (l.oldValue = n[i].value);
    let a = l.dir[s];
    a && (ut(), st(a, o, 8, [
      e.el,
      l,
      e,
      t
    ]), ft());
  }
}
const ul = Symbol("_vte"), fl = (e) => e.__isTeleport;
function js(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, js(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function dl(e, t) {
  return $(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    ne({ name: e.name }, t, { setup: e })
  ) : e;
}
function hn(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const pl = /* @__PURE__ */ new WeakSet();
function $o(e, t, o, s, r = !1) {
  if (k(e)) {
    e.forEach(
      (E, j) => $o(
        E,
        t && (k(t) ? t[j] : t),
        o,
        s,
        r
      )
    );
    return;
  }
  if (zt(s) && !r) {
    s.shapeFlag & 512 && s.type.__asyncResolved && s.component.subTree.component && $o(e, t, o, s.component.subTree);
    return;
  }
  const n = s.shapeFlag & 4 ? Qo(s.component) : s.el, i = r ? null : n, { i: l, r: a } = e;
  if (process.env.NODE_ENV !== "production" && !l) {
    D(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const p = t && t.r, d = l.refs === J ? l.refs = {} : l.refs, f = l.setupState, m = F(f), V = f === J ? () => !1 : (E) => process.env.NODE_ENV !== "production" && (B(m, E) && !ae(m[E]) && D(
    `Template ref "${E}" used on a non-ref value. It will not work in the production build.`
  ), pl.has(m[E])) ? !1 : B(m, E);
  if (p != null && p !== a && (re(p) ? (d[p] = null, V(p) && (f[p] = null)) : ae(p) && (p.value = null)), $(a))
    Ut(a, l, 12, [i, d]);
  else {
    const E = re(a), j = ae(a);
    if (E || j) {
      const te = () => {
        if (e.f) {
          const q = E ? V(a) ? f[a] : d[a] : a.value;
          r ? k(q) && Ds(q, n) : k(q) ? q.includes(n) || q.push(n) : E ? (d[a] = [n], V(a) && (f[a] = d[a])) : (a.value = [n], e.k && (d[e.k] = a.value));
        } else E ? (d[a] = i, V(a) && (f[a] = i)) : j ? (a.value = i, e.k && (d[e.k] = i)) : process.env.NODE_ENV !== "production" && D("Invalid template ref type:", a, `(${typeof a})`);
      };
      i ? (te.id = -1, ke(te, o)) : te();
    } else process.env.NODE_ENV !== "production" && D("Invalid template ref type:", a, `(${typeof a})`);
  }
}
uo().requestIdleCallback;
uo().cancelIdleCallback;
const zt = (e) => !!e.type.__asyncLoader, Fs = (e) => e.type.__isKeepAlive;
function hl(e, t) {
  gn(e, "a", t);
}
function gl(e, t) {
  gn(e, "da", t);
}
function gn(e, t, o = he) {
  const s = e.__wdc || (e.__wdc = () => {
    let r = o;
    for (; r; ) {
      if (r.isDeactivated)
        return;
      r = r.parent;
    }
    return e();
  });
  if (Yo(t, s, o), o) {
    let r = o.parent;
    for (; r && r.parent; )
      Fs(r.parent.vnode) && ml(s, t, o, r), r = r.parent;
  }
}
function ml(e, t, o, s) {
  const r = Yo(
    t,
    e,
    s,
    !0
    /* prepend */
  );
  mn(() => {
    Ds(s[t], r);
  }, o);
}
function Yo(e, t, o = he, s = !1) {
  if (o) {
    const r = o[e] || (o[e] = []), n = t.__weh || (t.__weh = (...i) => {
      ut();
      const l = mo(o), a = st(t, o, e, i);
      return l(), ft(), a;
    });
    return s ? r.unshift(n) : r.push(n), n;
  } else if (process.env.NODE_ENV !== "production") {
    const r = Nt(Ps[e].replace(/ hook$/, ""));
    D(
      `${r} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const dt = (e) => (t, o = he) => {
  (!co || e === "sp") && Yo(e, (...s) => t(...s), o);
}, bl = dt("bm"), vl = dt("m"), _l = dt(
  "bu"
), yl = dt("u"), wl = dt(
  "bum"
), mn = dt("um"), El = dt(
  "sp"
), xl = dt("rtg"), Nl = dt("rtc");
function Ol(e, t = he) {
  Yo("ec", e, t);
}
const Dl = Symbol.for("v-ndc");
function Gt(e, t, o, s) {
  let r;
  const n = o, i = k(e);
  if (i || re(e)) {
    const l = i && St(e);
    let a = !1;
    l && (a = !Oe(e), e = Wo(e)), r = new Array(e.length);
    for (let p = 0, d = e.length; p < d; p++)
      r[p] = t(
        a ? ye(e[p]) : e[p],
        p,
        void 0,
        n
      );
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && D(`The v-for range expect an integer value but got ${e}.`), r = new Array(e);
    for (let l = 0; l < e; l++)
      r[l] = t(l + 1, l, void 0, n);
  } else if (Q(e))
    if (e[Symbol.iterator])
      r = Array.from(
        e,
        (l, a) => t(l, a, void 0, n)
      );
    else {
      const l = Object.keys(e);
      r = new Array(l.length);
      for (let a = 0, p = l.length; a < p; a++) {
        const d = l[a];
        r[a] = t(e[d], d, a, n);
      }
    }
  else
    r = [];
  return r;
}
function Vl(e, t, o = {}, s, r) {
  if (de.ce || de.parent && zt(de.parent) && de.parent.ce)
    return K(), Es(
      le,
      null,
      [Re("slot", o, s)],
      64
    );
  let n = e[t];
  process.env.NODE_ENV !== "production" && n && n.length > 1 && (D(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), n = () => []), n && n._c && (n._d = !1), K();
  const i = n && bn(n(o)), l = o.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  i && i.key, a = Es(
    le,
    {
      key: (l && !at(l) ? l : `_${t}`) + // #7256 force differentiate fallback content from actual content
      ""
    },
    i || [],
    i && e._ === 1 ? 64 : -2
  );
  return a.scopeId && (a.slotScopeIds = [a.scopeId + "-s"]), n && n._c && (n._d = !0), a;
}
function bn(e) {
  return e.some((t) => go(t) ? !(t.type === Ce || t.type === le && !bn(t.children)) : !0) ? e : null;
}
const ms = (e) => e ? Un(e) ? Qo(e) : ms(e.parent) : null, Tt = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ ne(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? et(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? et(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? et(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? et(e.refs) : e.refs,
    $parent: (e) => ms(e.parent),
    $root: (e) => ms(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => yn(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      Jo(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = on.bind(e.proxy)),
    $watch: (e) => nc.bind(e)
  })
), zs = (e) => e === "_" || e === "$", is = (e, t) => e !== J && !e.__isScriptSetup && B(e, t), vn = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: o, setupState: s, data: r, props: n, accessCache: i, type: l, appContext: a } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let p;
    if (t[0] !== "$") {
      const V = i[t];
      if (V !== void 0)
        switch (V) {
          case 1:
            return s[t];
          case 2:
            return r[t];
          case 4:
            return o[t];
          case 3:
            return n[t];
        }
      else {
        if (is(s, t))
          return i[t] = 1, s[t];
        if (r !== J && B(r, t))
          return i[t] = 2, r[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (p = e.propsOptions[0]) && B(p, t)
        )
          return i[t] = 3, n[t];
        if (o !== J && B(o, t))
          return i[t] = 4, o[t];
        bs && (i[t] = 0);
      }
    }
    const d = Tt[t];
    let f, m;
    if (d)
      return t === "$attrs" ? (ue(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && jo()) : process.env.NODE_ENV !== "production" && t === "$slots" && ue(e, "get", t), d(e);
    if (
      // css module (injected by vue-loader)
      (f = l.__cssModules) && (f = f[t])
    )
      return f;
    if (o !== J && B(o, t))
      return i[t] = 4, o[t];
    if (
      // global properties
      m = a.config.globalProperties, B(m, t)
    )
      return m[t];
    process.env.NODE_ENV !== "production" && de && (!re(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (r !== J && zs(t[0]) && B(r, t) ? D(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === de && D(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, o) {
    const { data: s, setupState: r, ctx: n } = e;
    return is(r, t) ? (r[t] = o, !0) : process.env.NODE_ENV !== "production" && r.__isScriptSetup && B(r, t) ? (D(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : s !== J && B(s, t) ? (s[t] = o, !0) : B(e.props, t) ? (process.env.NODE_ENV !== "production" && D(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && D(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(n, t, {
      enumerable: !0,
      configurable: !0,
      value: o
    }) : n[t] = o, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: o, ctx: s, appContext: r, propsOptions: n }
  }, i) {
    let l;
    return !!o[i] || e !== J && B(e, i) || is(t, i) || (l = n[0]) && B(l, i) || B(s, i) || B(Tt, i) || B(r.config.globalProperties, i);
  },
  defineProperty(e, t, o) {
    return o.get != null ? e._.accessCache[t] = 0 : B(o, "value") && this.set(e, t, o.value, null), Reflect.defineProperty(e, t, o);
  }
};
process.env.NODE_ENV !== "production" && (vn.ownKeys = (e) => (D(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function Sl(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Tt).forEach((o) => {
    Object.defineProperty(t, o, {
      configurable: !0,
      enumerable: !1,
      get: () => Tt[o](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: fe
    });
  }), t;
}
function Cl(e) {
  const {
    ctx: t,
    propsOptions: [o]
  } = e;
  o && Object.keys(o).forEach((s) => {
    Object.defineProperty(t, s, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[s],
      set: fe
    });
  });
}
function Tl(e) {
  const { ctx: t, setupState: o } = e;
  Object.keys(F(o)).forEach((s) => {
    if (!o.__isScriptSetup) {
      if (zs(s[0])) {
        D(
          `setup() return property ${JSON.stringify(
            s
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, s, {
        enumerable: !0,
        configurable: !0,
        get: () => o[s],
        set: fe
      });
    }
  });
}
function er(e) {
  return k(e) ? e.reduce(
    (t, o) => (t[o] = null, t),
    {}
  ) : e;
}
function Al() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, o) => {
    e[o] ? D(`${t} property "${o}" is already defined in ${e[o]}.`) : e[o] = t;
  };
}
let bs = !0;
function Il(e) {
  const t = yn(e), o = e.proxy, s = e.ctx;
  bs = !1, t.beforeCreate && tr(t.beforeCreate, e, "bc");
  const {
    // state
    data: r,
    computed: n,
    methods: i,
    watch: l,
    provide: a,
    inject: p,
    // lifecycle
    created: d,
    beforeMount: f,
    mounted: m,
    beforeUpdate: V,
    updated: E,
    activated: j,
    deactivated: te,
    beforeDestroy: q,
    beforeUnmount: oe,
    destroyed: W,
    unmounted: be,
    render: A,
    renderTracked: ie,
    renderTriggered: De,
    errorCaptured: pe,
    serverPrefetch: ve,
    // public API
    expose: je,
    inheritAttrs: Ke,
    // assets
    components: Te,
    directives: we,
    filters: Bt
  } = t, He = process.env.NODE_ENV !== "production" ? Al() : null;
  if (process.env.NODE_ENV !== "production") {
    const [L] = e.propsOptions;
    if (L)
      for (const z in L)
        He("Props", z);
  }
  if (p && kl(p, s, He), i)
    for (const L in i) {
      const z = i[L];
      $(z) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(s, L, {
        value: z.bind(o),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : s[L] = z.bind(o), process.env.NODE_ENV !== "production" && He("Methods", L)) : process.env.NODE_ENV !== "production" && D(
        `Method "${L}" has type "${typeof z}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (r) {
    process.env.NODE_ENV !== "production" && !$(r) && D(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const L = r.call(o, o);
    if (process.env.NODE_ENV !== "production" && Vs(L) && D(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !Q(L))
      process.env.NODE_ENV !== "production" && D("data() should return an object.");
    else if (e.data = qo(L), process.env.NODE_ENV !== "production")
      for (const z in L)
        He("Data", z), zs(z[0]) || Object.defineProperty(s, z, {
          configurable: !0,
          enumerable: !0,
          get: () => L[z],
          set: fe
        });
  }
  if (bs = !0, n)
    for (const L in n) {
      const z = n[L], Ae = $(z) ? z.bind(o, o) : $(z.get) ? z.get.bind(o, o) : fe;
      process.env.NODE_ENV !== "production" && Ae === fe && D(`Computed property "${L}" has no getter.`);
      const It = !$(z) && $(z.set) ? z.set.bind(o) : process.env.NODE_ENV !== "production" ? () => {
        D(
          `Write operation failed: computed property "${L}" is readonly.`
        );
      } : fe, pt = Fe({
        get: Ae,
        set: It
      });
      Object.defineProperty(s, L, {
        enumerable: !0,
        configurable: !0,
        get: () => pt.value,
        set: (ht) => pt.value = ht
      }), process.env.NODE_ENV !== "production" && He("Computed", L);
    }
  if (l)
    for (const L in l)
      _n(l[L], s, o, L);
  if (a) {
    const L = $(a) ? a.call(o) : a;
    Reflect.ownKeys(L).forEach((z) => {
      En(z, L[z]);
    });
  }
  d && tr(d, e, "c");
  function ge(L, z) {
    k(z) ? z.forEach((Ae) => L(Ae.bind(o))) : z && L(z.bind(o));
  }
  if (ge(bl, f), ge(vl, m), ge(_l, V), ge(yl, E), ge(hl, j), ge(gl, te), ge(Ol, pe), ge(Nl, ie), ge(xl, De), ge(wl, oe), ge(mn, be), ge(El, ve), k(je))
    if (je.length) {
      const L = e.exposed || (e.exposed = {});
      je.forEach((z) => {
        Object.defineProperty(L, z, {
          get: () => o[z],
          set: (Ae) => o[z] = Ae
        });
      });
    } else e.exposed || (e.exposed = {});
  A && e.render === fe && (e.render = A), Ke != null && (e.inheritAttrs = Ke), Te && (e.components = Te), we && (e.directives = we), ve && hn(e);
}
function kl(e, t, o = fe) {
  k(e) && (e = vs(e));
  for (const s in e) {
    const r = e[s];
    let n;
    Q(r) ? "default" in r ? n = xo(
      r.from || s,
      r.default,
      !0
    ) : n = xo(r.from || s) : n = xo(r), ae(n) ? Object.defineProperty(t, s, {
      enumerable: !0,
      configurable: !0,
      get: () => n.value,
      set: (i) => n.value = i
    }) : t[s] = n, process.env.NODE_ENV !== "production" && o("Inject", s);
  }
}
function tr(e, t, o) {
  st(
    k(e) ? e.map((s) => s.bind(t.proxy)) : e.bind(t.proxy),
    t,
    o
  );
}
function _n(e, t, o, s) {
  let r = s.includes(".") ? Pn(o, s) : () => o[s];
  if (re(e)) {
    const n = t[e];
    $(n) ? Lt(r, n) : process.env.NODE_ENV !== "production" && D(`Invalid watch handler specified by key "${e}"`, n);
  } else if ($(e))
    Lt(r, e.bind(o));
  else if (Q(e))
    if (k(e))
      e.forEach((n) => _n(n, t, o, s));
    else {
      const n = $(e.handler) ? e.handler.bind(o) : t[e.handler];
      $(n) ? Lt(r, n, e) : process.env.NODE_ENV !== "production" && D(`Invalid watch handler specified by key "${e.handler}"`, n);
    }
  else process.env.NODE_ENV !== "production" && D(`Invalid watch option: "${s}"`, e);
}
function yn(e) {
  const t = e.type, { mixins: o, extends: s } = t, {
    mixins: r,
    optionsCache: n,
    config: { optionMergeStrategies: i }
  } = e.appContext, l = n.get(t);
  let a;
  return l ? a = l : !r.length && !o && !s ? a = t : (a = {}, r.length && r.forEach(
    (p) => Mo(a, p, i, !0)
  ), Mo(a, t, i)), Q(t) && n.set(t, a), a;
}
function Mo(e, t, o, s = !1) {
  const { mixins: r, extends: n } = t;
  n && Mo(e, n, o, !0), r && r.forEach(
    (i) => Mo(e, i, o, !0)
  );
  for (const i in t)
    if (s && i === "expose")
      process.env.NODE_ENV !== "production" && D(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const l = Pl[i] || o && o[i];
      e[i] = l ? l(e[i], t[i]) : t[i];
    }
  return e;
}
const Pl = {
  data: or,
  props: sr,
  emits: sr,
  // objects
  methods: Zt,
  computed: Zt,
  // lifecycle
  beforeCreate: xe,
  created: xe,
  beforeMount: xe,
  mounted: xe,
  beforeUpdate: xe,
  updated: xe,
  beforeDestroy: xe,
  beforeUnmount: xe,
  destroyed: xe,
  unmounted: xe,
  activated: xe,
  deactivated: xe,
  errorCaptured: xe,
  serverPrefetch: xe,
  // assets
  components: Zt,
  directives: Zt,
  // watch
  watch: Ml,
  // provide / inject
  provide: or,
  inject: $l
};
function or(e, t) {
  return t ? e ? function() {
    return ne(
      $(e) ? e.call(this, this) : e,
      $(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function $l(e, t) {
  return Zt(vs(e), vs(t));
}
function vs(e) {
  if (k(e)) {
    const t = {};
    for (let o = 0; o < e.length; o++)
      t[e[o]] = e[o];
    return t;
  }
  return e;
}
function xe(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Zt(e, t) {
  return e ? ne(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function sr(e, t) {
  return e ? k(e) && k(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : ne(
    /* @__PURE__ */ Object.create(null),
    er(e),
    er(t ?? {})
  ) : t;
}
function Ml(e, t) {
  if (!e) return t;
  if (!t) return e;
  const o = ne(/* @__PURE__ */ Object.create(null), e);
  for (const s in t)
    o[s] = xe(e[s], t[s]);
  return o;
}
function wn() {
  return {
    app: null,
    config: {
      isNativeTag: Xn,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Rl = 0;
function jl(e, t) {
  return function(s, r = null) {
    $(s) || (s = ne({}, s)), r != null && !Q(r) && (process.env.NODE_ENV !== "production" && D("root props passed to app.mount() must be an object."), r = null);
    const n = wn(), i = /* @__PURE__ */ new WeakSet(), l = [];
    let a = !1;
    const p = n.app = {
      _uid: Rl++,
      _component: s,
      _props: r,
      _container: null,
      _context: n,
      _instance: null,
      version: gr,
      get config() {
        return n.config;
      },
      set config(d) {
        process.env.NODE_ENV !== "production" && D(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(d, ...f) {
        return i.has(d) ? process.env.NODE_ENV !== "production" && D("Plugin has already been applied to target app.") : d && $(d.install) ? (i.add(d), d.install(p, ...f)) : $(d) ? (i.add(d), d(p, ...f)) : process.env.NODE_ENV !== "production" && D(
          'A plugin must either be a function or an object with an "install" function.'
        ), p;
      },
      mixin(d) {
        return n.mixins.includes(d) ? process.env.NODE_ENV !== "production" && D(
          "Mixin has already been applied to target app" + (d.name ? `: ${d.name}` : "")
        ) : n.mixins.push(d), p;
      },
      component(d, f) {
        return process.env.NODE_ENV !== "production" && Ns(d, n.config), f ? (process.env.NODE_ENV !== "production" && n.components[d] && D(`Component "${d}" has already been registered in target app.`), n.components[d] = f, p) : n.components[d];
      },
      directive(d, f) {
        return process.env.NODE_ENV !== "production" && pn(d), f ? (process.env.NODE_ENV !== "production" && n.directives[d] && D(`Directive "${d}" has already been registered in target app.`), n.directives[d] = f, p) : n.directives[d];
      },
      mount(d, f, m) {
        if (a)
          process.env.NODE_ENV !== "production" && D(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && d.__vue_app__ && D(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const V = p._ceVNode || Re(s, r);
          return V.appContext = n, m === !0 ? m = "svg" : m === !1 && (m = void 0), process.env.NODE_ENV !== "production" && (n.reload = () => {
            e(
              wt(V),
              d,
              m
            );
          }), e(V, d, m), a = !0, p._container = d, d.__vue_app__ = p, process.env.NODE_ENV !== "production" && (p._instance = V.component, tl(p, gr)), Qo(V.component);
        }
      },
      onUnmount(d) {
        process.env.NODE_ENV !== "production" && typeof d != "function" && D(
          `Expected function as first argument to app.onUnmount(), but got ${typeof d}`
        ), l.push(d);
      },
      unmount() {
        a ? (st(
          l,
          p._instance,
          16
        ), e(null, p._container), process.env.NODE_ENV !== "production" && (p._instance = null, ol(p)), delete p._container.__vue_app__) : process.env.NODE_ENV !== "production" && D("Cannot unmount an app that is not mounted.");
      },
      provide(d, f) {
        return process.env.NODE_ENV !== "production" && d in n.provides && D(
          `App already provides property with key "${String(d)}". It will be overwritten with the new value.`
        ), n.provides[d] = f, p;
      },
      runWithContext(d) {
        const f = Ht;
        Ht = p;
        try {
          return d();
        } finally {
          Ht = f;
        }
      }
    };
    return p;
  };
}
let Ht = null;
function En(e, t) {
  if (!he)
    process.env.NODE_ENV !== "production" && D("provide() can only be used inside setup().");
  else {
    let o = he.provides;
    const s = he.parent && he.parent.provides;
    s === o && (o = he.provides = Object.create(s)), o[e] = t;
  }
}
function xo(e, t, o = !1) {
  const s = he || de;
  if (s || Ht) {
    const r = Ht ? Ht._context.provides : s ? s.parent == null ? s.vnode.appContext && s.vnode.appContext.provides : s.parent.provides : void 0;
    if (r && e in r)
      return r[e];
    if (arguments.length > 1)
      return o && $(t) ? t.call(s && s.proxy) : t;
    process.env.NODE_ENV !== "production" && D(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && D("inject() can only be used inside setup() or functional components.");
}
const xn = {}, Nn = () => Object.create(xn), On = (e) => Object.getPrototypeOf(e) === xn;
function Fl(e, t, o, s = !1) {
  const r = {}, n = Nn();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Dn(e, t, r, n);
  for (const i in e.propsOptions[0])
    i in r || (r[i] = void 0);
  process.env.NODE_ENV !== "production" && Sn(t || {}, r, e), o ? e.props = s ? r : $i(r) : e.type.props ? e.props = r : e.props = n, e.attrs = n;
}
function zl(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function Hl(e, t, o, s) {
  const {
    props: r,
    attrs: n,
    vnode: { patchFlag: i }
  } = e, l = F(r), [a] = e.propsOptions;
  let p = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && zl(e)) && (s || i > 0) && !(i & 16)
  ) {
    if (i & 8) {
      const d = e.vnode.dynamicProps;
      for (let f = 0; f < d.length; f++) {
        let m = d[f];
        if (Xo(e.emitsOptions, m))
          continue;
        const V = t[m];
        if (a)
          if (B(n, m))
            V !== n[m] && (n[m] = V, p = !0);
          else {
            const E = Se(m);
            r[E] = _s(
              a,
              l,
              E,
              V,
              e,
              !1
            );
          }
        else
          V !== n[m] && (n[m] = V, p = !0);
      }
    }
  } else {
    Dn(e, t, r, n) && (p = !0);
    let d;
    for (const f in l)
      (!t || // for camelCase
      !B(t, f) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((d = $e(f)) === f || !B(t, d))) && (a ? o && // for camelCase
      (o[f] !== void 0 || // for kebab-case
      o[d] !== void 0) && (r[f] = _s(
        a,
        l,
        f,
        void 0,
        e,
        !0
      )) : delete r[f]);
    if (n !== l)
      for (const f in n)
        (!t || !B(t, f)) && (delete n[f], p = !0);
  }
  p && Ze(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && Sn(t || {}, r, e);
}
function Dn(e, t, o, s) {
  const [r, n] = e.propsOptions;
  let i = !1, l;
  if (t)
    for (let a in t) {
      if (eo(a))
        continue;
      const p = t[a];
      let d;
      r && B(r, d = Se(a)) ? !n || !n.includes(d) ? o[d] = p : (l || (l = {}))[d] = p : Xo(e.emitsOptions, a) || (!(a in s) || p !== s[a]) && (s[a] = p, i = !0);
    }
  if (n) {
    const a = F(o), p = l || J;
    for (let d = 0; d < n.length; d++) {
      const f = n[d];
      o[f] = _s(
        r,
        a,
        f,
        p[f],
        e,
        !B(p, f)
      );
    }
  }
  return i;
}
function _s(e, t, o, s, r, n) {
  const i = e[o];
  if (i != null) {
    const l = B(i, "default");
    if (l && s === void 0) {
      const a = i.default;
      if (i.type !== Function && !i.skipFactory && $(a)) {
        const { propsDefaults: p } = r;
        if (o in p)
          s = p[o];
        else {
          const d = mo(r);
          s = p[o] = a.call(
            null,
            t
          ), d();
        }
      } else
        s = a;
      r.ce && r.ce._setProp(o, s);
    }
    i[
      0
      /* shouldCast */
    ] && (n && !l ? s = !1 : i[
      1
      /* shouldCastTrue */
    ] && (s === "" || s === $e(o)) && (s = !0));
  }
  return s;
}
const Ll = /* @__PURE__ */ new WeakMap();
function Vn(e, t, o = !1) {
  const s = o ? Ll : t.propsCache, r = s.get(e);
  if (r)
    return r;
  const n = e.props, i = {}, l = [];
  let a = !1;
  if (!$(e)) {
    const d = (f) => {
      a = !0;
      const [m, V] = Vn(f, t, !0);
      ne(i, m), V && l.push(...V);
    };
    !o && t.mixins.length && t.mixins.forEach(d), e.extends && d(e.extends), e.mixins && e.mixins.forEach(d);
  }
  if (!n && !a)
    return Q(e) && s.set(e, jt), jt;
  if (k(n))
    for (let d = 0; d < n.length; d++) {
      process.env.NODE_ENV !== "production" && !re(n[d]) && D("props must be strings when using array syntax.", n[d]);
      const f = Se(n[d]);
      rr(f) && (i[f] = J);
    }
  else if (n) {
    process.env.NODE_ENV !== "production" && !Q(n) && D("invalid props options", n);
    for (const d in n) {
      const f = Se(d);
      if (rr(f)) {
        const m = n[d], V = i[f] = k(m) || $(m) ? { type: m } : ne({}, m), E = V.type;
        let j = !1, te = !0;
        if (k(E))
          for (let q = 0; q < E.length; ++q) {
            const oe = E[q], W = $(oe) && oe.name;
            if (W === "Boolean") {
              j = !0;
              break;
            } else W === "String" && (te = !1);
          }
        else
          j = $(E) && E.name === "Boolean";
        V[
          0
          /* shouldCast */
        ] = j, V[
          1
          /* shouldCastTrue */
        ] = te, (j || B(V, "default")) && l.push(f);
      }
    }
  }
  const p = [i, l];
  return Q(e) && s.set(e, p), p;
}
function rr(e) {
  return e[0] !== "$" && !eo(e) ? !0 : (process.env.NODE_ENV !== "production" && D(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Ul(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function Sn(e, t, o) {
  const s = F(t), r = o.propsOptions[0], n = Object.keys(e).map((i) => Se(i));
  for (const i in r) {
    let l = r[i];
    l != null && Bl(
      i,
      s[i],
      l,
      process.env.NODE_ENV !== "production" ? et(s) : s,
      !n.includes(i)
    );
  }
}
function Bl(e, t, o, s, r) {
  const { type: n, required: i, validator: l, skipCheck: a } = o;
  if (i && r) {
    D('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !i)) {
    if (n != null && n !== !0 && !a) {
      let p = !1;
      const d = k(n) ? n : [n], f = [];
      for (let m = 0; m < d.length && !p; m++) {
        const { valid: V, expectedType: E } = Kl(t, d[m]);
        f.push(E || ""), p = V;
      }
      if (!p) {
        D(ql(e, t, f));
        return;
      }
    }
    l && !l(t, s) && D('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const Wl = /* @__PURE__ */ ct(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Kl(e, t) {
  let o;
  const s = Ul(t);
  if (s === "null")
    o = e === null;
  else if (Wl(s)) {
    const r = typeof e;
    o = r === s.toLowerCase(), !o && r === "object" && (o = e instanceof t);
  } else s === "Object" ? o = Q(e) : s === "Array" ? o = k(e) : o = e instanceof t;
  return {
    valid: o,
    expectedType: s
  };
}
function ql(e, t, o) {
  if (o.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let s = `Invalid prop: type check failed for prop "${e}". Expected ${o.map(Bo).join(" | ")}`;
  const r = o[0], n = Ss(t), i = nr(t, r), l = nr(t, n);
  return o.length === 1 && ir(r) && !Gl(r, n) && (s += ` with value ${i}`), s += `, got ${n} `, ir(n) && (s += `with value ${l}.`), s;
}
function nr(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function ir(e) {
  return ["string", "number", "boolean"].some((o) => e.toLowerCase() === o);
}
function Gl(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Cn = (e) => e[0] === "_" || e === "$stable", Hs = (e) => k(e) ? e.map(Ue) : [Ue(e)], Jl = (e, t, o) => {
  if (t._n)
    return t;
  const s = dn((...r) => (process.env.NODE_ENV !== "production" && he && (!o || o.root === he.root) && D(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), Hs(t(...r))), o);
  return s._c = !1, s;
}, Tn = (e, t, o) => {
  const s = e._ctx;
  for (const r in e) {
    if (Cn(r)) continue;
    const n = e[r];
    if ($(n))
      t[r] = Jl(r, n, s);
    else if (n != null) {
      process.env.NODE_ENV !== "production" && D(
        `Non-function value encountered for slot "${r}". Prefer function slots for better performance.`
      );
      const i = Hs(n);
      t[r] = () => i;
    }
  }
}, An = (e, t) => {
  process.env.NODE_ENV !== "production" && !Fs(e.vnode) && D(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const o = Hs(t);
  e.slots.default = () => o;
}, ys = (e, t, o) => {
  for (const s in t)
    (o || s !== "_") && (e[s] = t[s]);
}, Yl = (e, t, o) => {
  const s = e.slots = Nn();
  if (e.vnode.shapeFlag & 32) {
    const r = t._;
    r ? (ys(s, t, o), o && Co(s, "_", r, !0)) : Tn(t, s);
  } else t && An(e, t);
}, Xl = (e, t, o) => {
  const { vnode: s, slots: r } = e;
  let n = !0, i = J;
  if (s.shapeFlag & 32) {
    const l = t._;
    l ? process.env.NODE_ENV !== "production" && tt ? (ys(r, t, o), Ze(e, "set", "$slots")) : o && l === 1 ? n = !1 : ys(r, t, o) : (n = !t.$stable, Tn(t, r)), i = t;
  } else t && (An(e, t), i = { default: 1 });
  if (n)
    for (const l in r)
      !Cn(l) && i[l] == null && delete r[l];
};
let Jt, _t;
function $t(e, t) {
  e.appContext.config.performance && Ro() && _t.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && il(e, t, Ro() ? _t.now() : Date.now());
}
function Mt(e, t) {
  if (e.appContext.config.performance && Ro()) {
    const o = `vue-${t}-${e.uid}`, s = o + ":end";
    _t.mark(s), _t.measure(
      `<${Zo(e, e.type)}> ${t}`,
      o,
      s
    ), _t.clearMarks(o), _t.clearMarks(s);
  }
  process.env.NODE_ENV !== "production" && ll(e, t, Ro() ? _t.now() : Date.now());
}
function Ro() {
  return Jt !== void 0 || (typeof window < "u" && window.performance ? (Jt = !0, _t = window.performance) : Jt = !1), Jt;
}
function Ql() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const ke = dc;
function Zl(e) {
  return ec(e);
}
function ec(e, t) {
  Ql();
  const o = uo();
  o.__VUE__ = !0, process.env.NODE_ENV !== "production" && Ms(o.__VUE_DEVTOOLS_GLOBAL_HOOK__, o);
  const {
    insert: s,
    remove: r,
    patchProp: n,
    createElement: i,
    createText: l,
    createComment: a,
    setText: p,
    setElementText: d,
    parentNode: f,
    nextSibling: m,
    setScopeId: V = fe,
    insertStaticContent: E
  } = e, j = (c, u, h, y = null, v = null, _ = null, S = void 0, O = null, N = process.env.NODE_ENV !== "production" && tt ? !1 : !!u.dynamicChildren) => {
    if (c === u)
      return;
    c && !Yt(c, u) && (y = b(c), Le(c, v, _, !0), c = null), u.patchFlag === -2 && (N = !1, u.dynamicChildren = null);
    const { type: w, ref: P, shapeFlag: C } = u;
    switch (w) {
      case ho:
        te(c, u, h, y);
        break;
      case Ce:
        q(c, u, h, y);
        break;
      case Oo:
        c == null ? oe(u, h, y, S) : process.env.NODE_ENV !== "production" && W(c, u, h, S);
        break;
      case le:
        we(
          c,
          u,
          h,
          y,
          v,
          _,
          S,
          O,
          N
        );
        break;
      default:
        C & 1 ? ie(
          c,
          u,
          h,
          y,
          v,
          _,
          S,
          O,
          N
        ) : C & 6 ? Bt(
          c,
          u,
          h,
          y,
          v,
          _,
          S,
          O,
          N
        ) : C & 64 || C & 128 ? w.process(
          c,
          u,
          h,
          y,
          v,
          _,
          S,
          O,
          N,
          se
        ) : process.env.NODE_ENV !== "production" && D("Invalid VNode type:", w, `(${typeof w})`);
    }
    P != null && v && $o(P, c && c.ref, _, u || c, !u);
  }, te = (c, u, h, y) => {
    if (c == null)
      s(
        u.el = l(u.children),
        h,
        y
      );
    else {
      const v = u.el = c.el;
      u.children !== c.children && p(v, u.children);
    }
  }, q = (c, u, h, y) => {
    c == null ? s(
      u.el = a(u.children || ""),
      h,
      y
    ) : u.el = c.el;
  }, oe = (c, u, h, y) => {
    [c.el, c.anchor] = E(
      c.children,
      u,
      h,
      y,
      c.el,
      c.anchor
    );
  }, W = (c, u, h, y) => {
    if (u.children !== c.children) {
      const v = m(c.anchor);
      A(c), [u.el, u.anchor] = E(
        u.children,
        h,
        v,
        y
      );
    } else
      u.el = c.el, u.anchor = c.anchor;
  }, be = ({ el: c, anchor: u }, h, y) => {
    let v;
    for (; c && c !== u; )
      v = m(c), s(c, h, y), c = v;
    s(u, h, y);
  }, A = ({ el: c, anchor: u }) => {
    let h;
    for (; c && c !== u; )
      h = m(c), r(c), c = h;
    r(u);
  }, ie = (c, u, h, y, v, _, S, O, N) => {
    u.type === "svg" ? S = "svg" : u.type === "math" && (S = "mathml"), c == null ? De(
      u,
      h,
      y,
      v,
      _,
      S,
      O,
      N
    ) : je(
      c,
      u,
      v,
      _,
      S,
      O,
      N
    );
  }, De = (c, u, h, y, v, _, S, O) => {
    let N, w;
    const { props: P, shapeFlag: C, transition: I, dirs: R } = c;
    if (N = c.el = i(
      c.type,
      _,
      P && P.is,
      P
    ), C & 8 ? d(N, c.children) : C & 16 && ve(
      c.children,
      N,
      null,
      y,
      v,
      ls(c, _),
      S,
      O
    ), R && Et(c, null, y, "created"), pe(N, c, c.scopeId, S, y), P) {
      for (const ee in P)
        ee !== "value" && !eo(ee) && n(N, ee, null, P[ee], _, y);
      "value" in P && n(N, "value", null, P.value, _), (w = P.onVnodeBeforeMount) && Xe(w, y, c);
    }
    process.env.NODE_ENV !== "production" && (Co(N, "__vnode", c, !0), Co(N, "__vueParentComponent", y, !0)), R && Et(c, null, y, "beforeMount");
    const U = tc(v, I);
    U && I.beforeEnter(N), s(N, u, h), ((w = P && P.onVnodeMounted) || U || R) && ke(() => {
      w && Xe(w, y, c), U && I.enter(N), R && Et(c, null, y, "mounted");
    }, v);
  }, pe = (c, u, h, y, v) => {
    if (h && V(c, h), y)
      for (let _ = 0; _ < y.length; _++)
        V(c, y[_]);
    if (v) {
      let _ = v.subTree;
      if (process.env.NODE_ENV !== "production" && _.patchFlag > 0 && _.patchFlag & 2048 && (_ = Ls(_.children) || _), u === _ || Rn(_.type) && (_.ssContent === u || _.ssFallback === u)) {
        const S = v.vnode;
        pe(
          c,
          S,
          S.scopeId,
          S.slotScopeIds,
          v.parent
        );
      }
    }
  }, ve = (c, u, h, y, v, _, S, O, N = 0) => {
    for (let w = N; w < c.length; w++) {
      const P = c[w] = O ? bt(c[w]) : Ue(c[w]);
      j(
        null,
        P,
        u,
        h,
        y,
        v,
        _,
        S,
        O
      );
    }
  }, je = (c, u, h, y, v, _, S) => {
    const O = u.el = c.el;
    process.env.NODE_ENV !== "production" && (O.__vnode = u);
    let { patchFlag: N, dynamicChildren: w, dirs: P } = u;
    N |= c.patchFlag & 16;
    const C = c.props || J, I = u.props || J;
    let R;
    if (h && xt(h, !1), (R = I.onVnodeBeforeUpdate) && Xe(R, h, u, c), P && Et(u, c, h, "beforeUpdate"), h && xt(h, !0), process.env.NODE_ENV !== "production" && tt && (N = 0, S = !1, w = null), (C.innerHTML && I.innerHTML == null || C.textContent && I.textContent == null) && d(O, ""), w ? (Ke(
      c.dynamicChildren,
      w,
      O,
      h,
      y,
      ls(u, v),
      _
    ), process.env.NODE_ENV !== "production" && No(c, u)) : S || Ae(
      c,
      u,
      O,
      null,
      h,
      y,
      ls(u, v),
      _,
      !1
    ), N > 0) {
      if (N & 16)
        Te(O, C, I, h, v);
      else if (N & 2 && C.class !== I.class && n(O, "class", null, I.class, v), N & 4 && n(O, "style", C.style, I.style, v), N & 8) {
        const U = u.dynamicProps;
        for (let ee = 0; ee < U.length; ee++) {
          const Y = U[ee], Ie = C[Y], Ve = I[Y];
          (Ve !== Ie || Y === "value") && n(O, Y, Ie, Ve, v, h);
        }
      }
      N & 1 && c.children !== u.children && d(O, u.children);
    } else !S && w == null && Te(O, C, I, h, v);
    ((R = I.onVnodeUpdated) || P) && ke(() => {
      R && Xe(R, h, u, c), P && Et(u, c, h, "updated");
    }, y);
  }, Ke = (c, u, h, y, v, _, S) => {
    for (let O = 0; O < u.length; O++) {
      const N = c[O], w = u[O], P = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        N.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (N.type === le || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Yt(N, w) || // - In the case of a component, it could contain anything.
        N.shapeFlag & 70) ? f(N.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          h
        )
      );
      j(
        N,
        w,
        P,
        null,
        y,
        v,
        _,
        S,
        !0
      );
    }
  }, Te = (c, u, h, y, v) => {
    if (u !== h) {
      if (u !== J)
        for (const _ in u)
          !eo(_) && !(_ in h) && n(
            c,
            _,
            u[_],
            null,
            v,
            y
          );
      for (const _ in h) {
        if (eo(_)) continue;
        const S = h[_], O = u[_];
        S !== O && _ !== "value" && n(c, _, O, S, v, y);
      }
      "value" in h && n(c, "value", u.value, h.value, v);
    }
  }, we = (c, u, h, y, v, _, S, O, N) => {
    const w = u.el = c ? c.el : l(""), P = u.anchor = c ? c.anchor : l("");
    let { patchFlag: C, dynamicChildren: I, slotScopeIds: R } = u;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (tt || C & 2048) && (C = 0, N = !1, I = null), R && (O = O ? O.concat(R) : R), c == null ? (s(w, h, y), s(P, h, y), ve(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      u.children || [],
      h,
      P,
      v,
      _,
      S,
      O,
      N
    )) : C > 0 && C & 64 && I && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    c.dynamicChildren ? (Ke(
      c.dynamicChildren,
      I,
      h,
      v,
      _,
      S,
      O
    ), process.env.NODE_ENV !== "production" ? No(c, u) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (u.key != null || v && u === v.subTree) && No(
        c,
        u,
        !0
        /* shallow */
      )
    )) : Ae(
      c,
      u,
      h,
      P,
      v,
      _,
      S,
      O,
      N
    );
  }, Bt = (c, u, h, y, v, _, S, O, N) => {
    u.slotScopeIds = O, c == null ? u.shapeFlag & 512 ? v.ctx.activate(
      u,
      h,
      y,
      S,
      N
    ) : He(
      u,
      h,
      y,
      v,
      _,
      S,
      N
    ) : ge(c, u, N);
  }, He = (c, u, h, y, v, _, S) => {
    const O = c.component = _c(
      c,
      y,
      v
    );
    if (process.env.NODE_ENV !== "production" && O.type.__hmrId && Xi(O), process.env.NODE_ENV !== "production" && (yo(c), $t(O, "mount")), Fs(c) && (O.ctx.renderer = se), process.env.NODE_ENV !== "production" && $t(O, "init"), Ec(O, !1, S), process.env.NODE_ENV !== "production" && Mt(O, "init"), O.asyncDep) {
      if (process.env.NODE_ENV !== "production" && tt && (c.el = null), v && v.registerDep(O, L, S), !c.el) {
        const N = O.subTree = Re(Ce);
        q(null, N, u, h);
      }
    } else
      L(
        O,
        c,
        u,
        h,
        v,
        _,
        S
      );
    process.env.NODE_ENV !== "production" && (wo(), Mt(O, "mount"));
  }, ge = (c, u, h) => {
    const y = u.component = c.component;
    if (uc(c, u, h))
      if (y.asyncDep && !y.asyncResolved) {
        process.env.NODE_ENV !== "production" && yo(u), z(y, u, h), process.env.NODE_ENV !== "production" && wo();
        return;
      } else
        y.next = u, y.update();
    else
      u.el = c.el, y.vnode = u;
  }, L = (c, u, h, y, v, _, S) => {
    const O = () => {
      if (c.isMounted) {
        let { next: C, bu: I, u: R, parent: U, vnode: ee } = c;
        {
          const Je = In(c);
          if (Je) {
            C && (C.el = ee.el, z(c, C, S)), Je.asyncDep.then(() => {
              c.isUnmounted || O();
            });
            return;
          }
        }
        let Y = C, Ie;
        process.env.NODE_ENV !== "production" && yo(C || c.vnode), xt(c, !1), C ? (C.el = ee.el, z(c, C, S)) : C = ee, I && Kt(I), (Ie = C.props && C.props.onVnodeBeforeUpdate) && Xe(Ie, U, C, ee), xt(c, !0), process.env.NODE_ENV !== "production" && $t(c, "render");
        const Ve = cr(c);
        process.env.NODE_ENV !== "production" && Mt(c, "render");
        const Ge = c.subTree;
        c.subTree = Ve, process.env.NODE_ENV !== "production" && $t(c, "patch"), j(
          Ge,
          Ve,
          // parent may have changed if it's in a teleport
          f(Ge.el),
          // anchor may have changed if it's in a fragment
          b(Ge),
          c,
          v,
          _
        ), process.env.NODE_ENV !== "production" && Mt(c, "patch"), C.el = Ve.el, Y === null && fc(c, Ve.el), R && ke(R, v), (Ie = C.props && C.props.onVnodeUpdated) && ke(
          () => Xe(Ie, U, C, ee),
          v
        ), process.env.NODE_ENV !== "production" && an(c), process.env.NODE_ENV !== "production" && wo();
      } else {
        let C;
        const { el: I, props: R } = u, { bm: U, m: ee, parent: Y, root: Ie, type: Ve } = c, Ge = zt(u);
        xt(c, !1), U && Kt(U), !Ge && (C = R && R.onVnodeBeforeMount) && Xe(C, Y, u), xt(c, !0);
        {
          Ie.ce && Ie.ce._injectChildStyle(Ve), process.env.NODE_ENV !== "production" && $t(c, "render");
          const Je = c.subTree = cr(c);
          process.env.NODE_ENV !== "production" && Mt(c, "render"), process.env.NODE_ENV !== "production" && $t(c, "patch"), j(
            null,
            Je,
            h,
            y,
            c,
            v,
            _
          ), process.env.NODE_ENV !== "production" && Mt(c, "patch"), u.el = Je.el;
        }
        if (ee && ke(ee, v), !Ge && (C = R && R.onVnodeMounted)) {
          const Je = u;
          ke(
            () => Xe(C, Y, Je),
            v
          );
        }
        (u.shapeFlag & 256 || Y && zt(Y.vnode) && Y.vnode.shapeFlag & 256) && c.a && ke(c.a, v), c.isMounted = !0, process.env.NODE_ENV !== "production" && sl(c), u = h = y = null;
      }
    };
    c.scope.on();
    const N = c.effect = new $r(O);
    c.scope.off();
    const w = c.update = N.run.bind(N), P = c.job = N.runIfDirty.bind(N);
    P.i = c, P.id = c.uid, N.scheduler = () => Jo(P), xt(c, !0), process.env.NODE_ENV !== "production" && (N.onTrack = c.rtc ? (C) => Kt(c.rtc, C) : void 0, N.onTrigger = c.rtg ? (C) => Kt(c.rtg, C) : void 0), w();
  }, z = (c, u, h) => {
    u.component = c;
    const y = c.vnode.props;
    c.vnode = u, c.next = null, Hl(c, u.props, y, h), Xl(c, u.children, h), ut(), Qs(c), ft();
  }, Ae = (c, u, h, y, v, _, S, O, N = !1) => {
    const w = c && c.children, P = c ? c.shapeFlag : 0, C = u.children, { patchFlag: I, shapeFlag: R } = u;
    if (I > 0) {
      if (I & 128) {
        pt(
          w,
          C,
          h,
          y,
          v,
          _,
          S,
          O,
          N
        );
        return;
      } else if (I & 256) {
        It(
          w,
          C,
          h,
          y,
          v,
          _,
          S,
          O,
          N
        );
        return;
      }
    }
    R & 8 ? (P & 16 && x(w, v, _), C !== w && d(h, C)) : P & 16 ? R & 16 ? pt(
      w,
      C,
      h,
      y,
      v,
      _,
      S,
      O,
      N
    ) : x(w, v, _, !0) : (P & 8 && d(h, ""), R & 16 && ve(
      C,
      h,
      y,
      v,
      _,
      S,
      O,
      N
    ));
  }, It = (c, u, h, y, v, _, S, O, N) => {
    c = c || jt, u = u || jt;
    const w = c.length, P = u.length, C = Math.min(w, P);
    let I;
    for (I = 0; I < C; I++) {
      const R = u[I] = N ? bt(u[I]) : Ue(u[I]);
      j(
        c[I],
        R,
        h,
        null,
        v,
        _,
        S,
        O,
        N
      );
    }
    w > P ? x(
      c,
      v,
      _,
      !0,
      !1,
      C
    ) : ve(
      u,
      h,
      y,
      v,
      _,
      S,
      O,
      N,
      C
    );
  }, pt = (c, u, h, y, v, _, S, O, N) => {
    let w = 0;
    const P = u.length;
    let C = c.length - 1, I = P - 1;
    for (; w <= C && w <= I; ) {
      const R = c[w], U = u[w] = N ? bt(u[w]) : Ue(u[w]);
      if (Yt(R, U))
        j(
          R,
          U,
          h,
          null,
          v,
          _,
          S,
          O,
          N
        );
      else
        break;
      w++;
    }
    for (; w <= C && w <= I; ) {
      const R = c[C], U = u[I] = N ? bt(u[I]) : Ue(u[I]);
      if (Yt(R, U))
        j(
          R,
          U,
          h,
          null,
          v,
          _,
          S,
          O,
          N
        );
      else
        break;
      C--, I--;
    }
    if (w > C) {
      if (w <= I) {
        const R = I + 1, U = R < P ? u[R].el : y;
        for (; w <= I; )
          j(
            null,
            u[w] = N ? bt(u[w]) : Ue(u[w]),
            h,
            U,
            v,
            _,
            S,
            O,
            N
          ), w++;
      }
    } else if (w > I)
      for (; w <= C; )
        Le(c[w], v, _, !0), w++;
    else {
      const R = w, U = w, ee = /* @__PURE__ */ new Map();
      for (w = U; w <= I; w++) {
        const Ee = u[w] = N ? bt(u[w]) : Ue(u[w]);
        Ee.key != null && (process.env.NODE_ENV !== "production" && ee.has(Ee.key) && D(
          "Duplicate keys found during update:",
          JSON.stringify(Ee.key),
          "Make sure keys are unique."
        ), ee.set(Ee.key, w));
      }
      let Y, Ie = 0;
      const Ve = I - U + 1;
      let Ge = !1, Je = 0;
      const Wt = new Array(Ve);
      for (w = 0; w < Ve; w++) Wt[w] = 0;
      for (w = R; w <= C; w++) {
        const Ee = c[w];
        if (Ie >= Ve) {
          Le(Ee, v, _, !0);
          continue;
        }
        let Ye;
        if (Ee.key != null)
          Ye = ee.get(Ee.key);
        else
          for (Y = U; Y <= I; Y++)
            if (Wt[Y - U] === 0 && Yt(Ee, u[Y])) {
              Ye = Y;
              break;
            }
        Ye === void 0 ? Le(Ee, v, _, !0) : (Wt[Ye - U] = w + 1, Ye >= Je ? Je = Ye : Ge = !0, j(
          Ee,
          u[Ye],
          h,
          null,
          v,
          _,
          S,
          O,
          N
        ), Ie++);
      }
      const Ws = Ge ? oc(Wt) : jt;
      for (Y = Ws.length - 1, w = Ve - 1; w >= 0; w--) {
        const Ee = U + w, Ye = u[Ee], Ks = Ee + 1 < P ? u[Ee + 1].el : y;
        Wt[w] === 0 ? j(
          null,
          Ye,
          h,
          Ks,
          v,
          _,
          S,
          O,
          N
        ) : Ge && (Y < 0 || w !== Ws[Y] ? ht(Ye, h, Ks, 2) : Y--);
      }
    }
  }, ht = (c, u, h, y, v = null) => {
    const { el: _, type: S, transition: O, children: N, shapeFlag: w } = c;
    if (w & 6) {
      ht(c.component.subTree, u, h, y);
      return;
    }
    if (w & 128) {
      c.suspense.move(u, h, y);
      return;
    }
    if (w & 64) {
      S.move(c, u, h, se);
      return;
    }
    if (S === le) {
      s(_, u, h);
      for (let C = 0; C < N.length; C++)
        ht(N[C], u, h, y);
      s(c.anchor, u, h);
      return;
    }
    if (S === Oo) {
      be(c, u, h);
      return;
    }
    if (y !== 2 && w & 1 && O)
      if (y === 0)
        O.beforeEnter(_), s(_, u, h), ke(() => O.enter(_), v);
      else {
        const { leave: C, delayLeave: I, afterLeave: R } = O, U = () => s(_, u, h), ee = () => {
          C(_, () => {
            U(), R && R();
          });
        };
        I ? I(_, U, ee) : ee();
      }
    else
      s(_, u, h);
  }, Le = (c, u, h, y = !1, v = !1) => {
    const {
      type: _,
      props: S,
      ref: O,
      children: N,
      dynamicChildren: w,
      shapeFlag: P,
      patchFlag: C,
      dirs: I,
      cacheIndex: R
    } = c;
    if (C === -2 && (v = !1), O != null && $o(O, null, h, c, !0), R != null && (u.renderCache[R] = void 0), P & 256) {
      u.ctx.deactivate(c);
      return;
    }
    const U = P & 1 && I, ee = !zt(c);
    let Y;
    if (ee && (Y = S && S.onVnodeBeforeUnmount) && Xe(Y, u, c), P & 6)
      g(c.component, h, y);
    else {
      if (P & 128) {
        c.suspense.unmount(h, y);
        return;
      }
      U && Et(c, null, u, "beforeUnmount"), P & 64 ? c.type.remove(
        c,
        u,
        h,
        se,
        y
      ) : w && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !w.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (_ !== le || C > 0 && C & 64) ? x(
        w,
        u,
        h,
        !1,
        !0
      ) : (_ === le && C & 384 || !v && P & 16) && x(N, u, h), y && gt(c);
    }
    (ee && (Y = S && S.onVnodeUnmounted) || U) && ke(() => {
      Y && Xe(Y, u, c), U && Et(c, null, u, "unmounted");
    }, h);
  }, gt = (c) => {
    const { type: u, el: h, anchor: y, transition: v } = c;
    if (u === le) {
      process.env.NODE_ENV !== "production" && c.patchFlag > 0 && c.patchFlag & 2048 && v && !v.persisted ? c.children.forEach((S) => {
        S.type === Ce ? r(S.el) : gt(S);
      }) : qe(h, y);
      return;
    }
    if (u === Oo) {
      A(c);
      return;
    }
    const _ = () => {
      r(h), v && !v.persisted && v.afterLeave && v.afterLeave();
    };
    if (c.shapeFlag & 1 && v && !v.persisted) {
      const { leave: S, delayLeave: O } = v, N = () => S(h, _);
      O ? O(c.el, _, N) : N();
    } else
      _();
  }, qe = (c, u) => {
    let h;
    for (; c !== u; )
      h = m(c), r(c), c = h;
    r(u);
  }, g = (c, u, h) => {
    process.env.NODE_ENV !== "production" && c.type.__hmrId && Qi(c);
    const { bum: y, scope: v, job: _, subTree: S, um: O, m: N, a: w } = c;
    lr(N), lr(w), y && Kt(y), v.stop(), _ && (_.flags |= 8, Le(S, c, u, h)), O && ke(O, u), ke(() => {
      c.isUnmounted = !0;
    }, u), u && u.pendingBranch && !u.isUnmounted && c.asyncDep && !c.asyncResolved && c.suspenseId === u.pendingId && (u.deps--, u.deps === 0 && u.resolve()), process.env.NODE_ENV !== "production" && nl(c);
  }, x = (c, u, h, y = !1, v = !1, _ = 0) => {
    for (let S = _; S < c.length; S++)
      Le(c[S], u, h, y, v);
  }, b = (c) => {
    if (c.shapeFlag & 6)
      return b(c.component.subTree);
    if (c.shapeFlag & 128)
      return c.suspense.next();
    const u = m(c.anchor || c.el), h = u && u[ul];
    return h ? m(h) : u;
  };
  let T = !1;
  const H = (c, u, h) => {
    c == null ? u._vnode && Le(u._vnode, null, null, !0) : j(
      u._vnode || null,
      c,
      u,
      null,
      null,
      null,
      h
    ), u._vnode = c, T || (T = !0, Qs(), nn(), T = !1);
  }, se = {
    p: j,
    um: Le,
    m: ht,
    r: gt,
    mt: He,
    mc: ve,
    pc: Ae,
    pbc: Ke,
    n: b,
    o: e
  };
  return {
    render: H,
    hydrate: void 0,
    createApp: jl(H)
  };
}
function ls({ type: e, props: t }, o) {
  return o === "svg" && e === "foreignObject" || o === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : o;
}
function xt({ effect: e, job: t }, o) {
  o ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function tc(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function No(e, t, o = !1) {
  const s = e.children, r = t.children;
  if (k(s) && k(r))
    for (let n = 0; n < s.length; n++) {
      const i = s[n];
      let l = r[n];
      l.shapeFlag & 1 && !l.dynamicChildren && ((l.patchFlag <= 0 || l.patchFlag === 32) && (l = r[n] = bt(r[n]), l.el = i.el), !o && l.patchFlag !== -2 && No(i, l)), l.type === ho && (l.el = i.el), process.env.NODE_ENV !== "production" && l.type === Ce && !l.el && (l.el = i.el);
    }
}
function oc(e) {
  const t = e.slice(), o = [0];
  let s, r, n, i, l;
  const a = e.length;
  for (s = 0; s < a; s++) {
    const p = e[s];
    if (p !== 0) {
      if (r = o[o.length - 1], e[r] < p) {
        t[s] = r, o.push(s);
        continue;
      }
      for (n = 0, i = o.length - 1; n < i; )
        l = n + i >> 1, e[o[l]] < p ? n = l + 1 : i = l;
      p < e[o[n]] && (n > 0 && (t[s] = o[n - 1]), o[n] = s);
    }
  }
  for (n = o.length, i = o[n - 1]; n-- > 0; )
    o[n] = i, i = t[i];
  return o;
}
function In(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : In(t);
}
function lr(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const sc = Symbol.for("v-scx"), rc = () => {
  {
    const e = xo(sc);
    return e || process.env.NODE_ENV !== "production" && D(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Lt(e, t, o) {
  return process.env.NODE_ENV !== "production" && !$(t) && D(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), kn(e, t, o);
}
function kn(e, t, o = J) {
  const { immediate: s, deep: r, flush: n, once: i } = o;
  process.env.NODE_ENV !== "production" && !t && (s !== void 0 && D(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), r !== void 0 && D(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), i !== void 0 && D(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const l = ne({}, o);
  process.env.NODE_ENV !== "production" && (l.onWarn = D);
  const a = t && s || !t && n !== "post";
  let p;
  if (co) {
    if (n === "sync") {
      const V = rc();
      p = V.__watcherHandles || (V.__watcherHandles = []);
    } else if (!a) {
      const V = () => {
      };
      return V.stop = fe, V.resume = fe, V.pause = fe, V;
    }
  }
  const d = he;
  l.call = (V, E, j) => st(V, d, E, j);
  let f = !1;
  n === "post" ? l.scheduler = (V) => {
    ke(V, d && d.suspense);
  } : n !== "sync" && (f = !0, l.scheduler = (V, E) => {
    E ? V() : Jo(V);
  }), l.augmentJob = (V) => {
    t && (V.flags |= 4), f && (V.flags |= 2, d && (V.id = d.uid, V.i = d));
  };
  const m = Ui(e, t, l);
  return co && (p ? p.push(m) : a && m()), m;
}
function nc(e, t, o) {
  const s = this.proxy, r = re(e) ? e.includes(".") ? Pn(s, e) : () => s[e] : e.bind(s, s);
  let n;
  $(t) ? n = t : (n = t.handler, o = t);
  const i = mo(this), l = kn(r, n.bind(s), o);
  return i(), l;
}
function Pn(e, t) {
  const o = t.split(".");
  return () => {
    let s = e;
    for (let r = 0; r < o.length && s; r++)
      s = s[o[r]];
    return s;
  };
}
const ic = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${Se(t)}Modifiers`] || e[`${$e(t)}Modifiers`];
function lc(e, t, ...o) {
  if (e.isUnmounted) return;
  const s = e.vnode.props || J;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: d,
      propsOptions: [f]
    } = e;
    if (d)
      if (!(t in d))
        (!f || !(Nt(Se(t)) in f)) && D(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${Nt(Se(t))}" prop.`
        );
      else {
        const m = d[t];
        $(m) && (m(...o) || D(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let r = o;
  const n = t.startsWith("update:"), i = n && ic(s, t.slice(7));
  if (i && (i.trim && (r = o.map((d) => re(d) ? d.trim() : d)), i.number && (r = o.map(oi))), process.env.NODE_ENV !== "production" && cl(e, t, r), process.env.NODE_ENV !== "production") {
    const d = t.toLowerCase();
    d !== t && s[Nt(d)] && D(
      `Event "${d}" is emitted in component ${Zo(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${$e(
        t
      )}" instead of "${t}".`
    );
  }
  let l, a = s[l = Nt(t)] || // also try camelCase event handler (#2249)
  s[l = Nt(Se(t))];
  !a && n && (a = s[l = Nt($e(t))]), a && st(
    a,
    e,
    6,
    r
  );
  const p = s[l + "Once"];
  if (p) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[l])
      return;
    e.emitted[l] = !0, st(
      p,
      e,
      6,
      r
    );
  }
}
function $n(e, t, o = !1) {
  const s = t.emitsCache, r = s.get(e);
  if (r !== void 0)
    return r;
  const n = e.emits;
  let i = {}, l = !1;
  if (!$(e)) {
    const a = (p) => {
      const d = $n(p, t, !0);
      d && (l = !0, ne(i, d));
    };
    !o && t.mixins.length && t.mixins.forEach(a), e.extends && a(e.extends), e.mixins && e.mixins.forEach(a);
  }
  return !n && !l ? (Q(e) && s.set(e, null), null) : (k(n) ? n.forEach((a) => i[a] = null) : ne(i, n), Q(e) && s.set(e, i), i);
}
function Xo(e, t) {
  return !e || !ao(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), B(e, t[0].toLowerCase() + t.slice(1)) || B(e, $e(t)) || B(e, t));
}
let ws = !1;
function jo() {
  ws = !0;
}
function cr(e) {
  const {
    type: t,
    vnode: o,
    proxy: s,
    withProxy: r,
    propsOptions: [n],
    slots: i,
    attrs: l,
    emit: a,
    render: p,
    renderCache: d,
    props: f,
    data: m,
    setupState: V,
    ctx: E,
    inheritAttrs: j
  } = e, te = Po(e);
  let q, oe;
  process.env.NODE_ENV !== "production" && (ws = !1);
  try {
    if (o.shapeFlag & 4) {
      const A = r || s, ie = process.env.NODE_ENV !== "production" && V.__isScriptSetup ? new Proxy(A, {
        get(De, pe, ve) {
          return D(
            `Property '${String(
              pe
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(De, pe, ve);
        }
      }) : A;
      q = Ue(
        p.call(
          ie,
          A,
          d,
          process.env.NODE_ENV !== "production" ? et(f) : f,
          V,
          m,
          E
        )
      ), oe = l;
    } else {
      const A = t;
      process.env.NODE_ENV !== "production" && l === f && jo(), q = Ue(
        A.length > 1 ? A(
          process.env.NODE_ENV !== "production" ? et(f) : f,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return jo(), et(l);
            },
            slots: i,
            emit: a
          } : { attrs: l, slots: i, emit: a }
        ) : A(
          process.env.NODE_ENV !== "production" ? et(f) : f,
          null
        )
      ), oe = t.props ? l : cc(l);
    }
  } catch (A) {
    so.length = 0, fo(A, e, 1), q = Re(Ce);
  }
  let W = q, be;
  if (process.env.NODE_ENV !== "production" && q.patchFlag > 0 && q.patchFlag & 2048 && ([W, be] = Mn(q)), oe && j !== !1) {
    const A = Object.keys(oe), { shapeFlag: ie } = W;
    if (A.length) {
      if (ie & 7)
        n && A.some(So) && (oe = ac(
          oe,
          n
        )), W = wt(W, oe, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !ws && W.type !== Ce) {
        const De = Object.keys(l), pe = [], ve = [];
        for (let je = 0, Ke = De.length; je < Ke; je++) {
          const Te = De[je];
          ao(Te) ? So(Te) || pe.push(Te[2].toLowerCase() + Te.slice(3)) : ve.push(Te);
        }
        ve.length && D(
          `Extraneous non-props attributes (${ve.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
        ), pe.length && D(
          `Extraneous non-emits event listeners (${pe.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return o.dirs && (process.env.NODE_ENV !== "production" && !ar(W) && D(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), W = wt(W, null, !1, !0), W.dirs = W.dirs ? W.dirs.concat(o.dirs) : o.dirs), o.transition && (process.env.NODE_ENV !== "production" && !ar(W) && D(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), js(W, o.transition)), process.env.NODE_ENV !== "production" && be ? be(W) : q = W, Po(te), q;
}
const Mn = (e) => {
  const t = e.children, o = e.dynamicChildren, s = Ls(t, !1);
  if (s) {
    if (process.env.NODE_ENV !== "production" && s.patchFlag > 0 && s.patchFlag & 2048)
      return Mn(s);
  } else return [e, void 0];
  const r = t.indexOf(s), n = o ? o.indexOf(s) : -1, i = (l) => {
    t[r] = l, o && (n > -1 ? o[n] = l : l.patchFlag > 0 && (e.dynamicChildren = [...o, l]));
  };
  return [Ue(s), i];
};
function Ls(e, t = !0) {
  let o;
  for (let s = 0; s < e.length; s++) {
    const r = e[s];
    if (go(r)) {
      if (r.type !== Ce || r.children === "v-if") {
        if (o)
          return;
        if (o = r, process.env.NODE_ENV !== "production" && t && o.patchFlag > 0 && o.patchFlag & 2048)
          return Ls(o.children);
      }
    } else
      return;
  }
  return o;
}
const cc = (e) => {
  let t;
  for (const o in e)
    (o === "class" || o === "style" || ao(o)) && ((t || (t = {}))[o] = e[o]);
  return t;
}, ac = (e, t) => {
  const o = {};
  for (const s in e)
    (!So(s) || !(s.slice(9) in t)) && (o[s] = e[s]);
  return o;
}, ar = (e) => e.shapeFlag & 7 || e.type === Ce;
function uc(e, t, o) {
  const { props: s, children: r, component: n } = e, { props: i, children: l, patchFlag: a } = t, p = n.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (r || l) && tt || t.dirs || t.transition)
    return !0;
  if (o && a >= 0) {
    if (a & 1024)
      return !0;
    if (a & 16)
      return s ? ur(s, i, p) : !!i;
    if (a & 8) {
      const d = t.dynamicProps;
      for (let f = 0; f < d.length; f++) {
        const m = d[f];
        if (i[m] !== s[m] && !Xo(p, m))
          return !0;
      }
    }
  } else
    return (r || l) && (!l || !l.$stable) ? !0 : s === i ? !1 : s ? i ? ur(s, i, p) : !0 : !!i;
  return !1;
}
function ur(e, t, o) {
  const s = Object.keys(t);
  if (s.length !== Object.keys(e).length)
    return !0;
  for (let r = 0; r < s.length; r++) {
    const n = s[r];
    if (t[n] !== e[n] && !Xo(o, n))
      return !0;
  }
  return !1;
}
function fc({ vnode: e, parent: t }, o) {
  for (; t; ) {
    const s = t.subTree;
    if (s.suspense && s.suspense.activeBranch === e && (s.el = e.el), s === e)
      (e = t.vnode).el = o, t = t.parent;
    else
      break;
  }
}
const Rn = (e) => e.__isSuspense;
function dc(e, t) {
  t && t.pendingBranch ? k(e) ? t.effects.push(...e) : t.effects.push(e) : rn(e);
}
const le = Symbol.for("v-fgt"), ho = Symbol.for("v-txt"), Ce = Symbol.for("v-cmt"), Oo = Symbol.for("v-stc"), so = [];
let Me = null;
function K(e = !1) {
  so.push(Me = e ? null : []);
}
function pc() {
  so.pop(), Me = so[so.length - 1] || null;
}
let lo = 1;
function fr(e, t = !1) {
  lo += e, e < 0 && Me && t && (Me.hasOnce = !0);
}
function jn(e) {
  return e.dynamicChildren = lo > 0 ? Me || jt : null, pc(), lo > 0 && Me && Me.push(e), e;
}
function X(e, t, o, s, r, n) {
  return jn(
    M(
      e,
      t,
      o,
      s,
      r,
      n,
      !0
    )
  );
}
function Es(e, t, o, s, r) {
  return jn(
    Re(
      e,
      t,
      o,
      s,
      r,
      !0
    )
  );
}
function go(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Yt(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const o = Eo.get(t.type);
    if (o && o.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const hc = (...e) => zn(
  ...e
), Fn = ({ key: e }) => e ?? null, Do = ({
  ref: e,
  ref_key: t,
  ref_for: o
}) => (typeof e == "number" && (e = "" + e), e != null ? re(e) || ae(e) || $(e) ? { i: de, r: e, k: t, f: !!o } : e : null);
function M(e, t = null, o = null, s = 0, r = null, n = e === le ? 0 : 1, i = !1, l = !1) {
  const a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && Fn(t),
    ref: t && Do(t),
    scopeId: fn,
    slotScopeIds: null,
    children: o,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: n,
    patchFlag: s,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: de
  };
  return l ? (Us(a, o), n & 128 && e.normalize(a)) : o && (a.shapeFlag |= re(o) ? 8 : 16), process.env.NODE_ENV !== "production" && a.key !== a.key && D("VNode created with invalid key (NaN). VNode type:", a.type), lo > 0 && // avoid a block node from tracking itself
  !i && // has current parent block
  Me && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (a.patchFlag > 0 || n & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  a.patchFlag !== 32 && Me.push(a), a;
}
const Re = process.env.NODE_ENV !== "production" ? hc : zn;
function zn(e, t = null, o = null, s = 0, r = null, n = !1) {
  if ((!e || e === Dl) && (process.env.NODE_ENV !== "production" && !e && D(`Invalid vnode type when creating vnode: ${e}.`), e = Ce), go(e)) {
    const l = wt(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return o && Us(l, o), lo > 0 && !n && Me && (l.shapeFlag & 6 ? Me[Me.indexOf(e)] = l : Me.push(l)), l.patchFlag = -2, l;
  }
  if (Kn(e) && (e = e.__vccOpts), t) {
    t = gc(t);
    let { class: l, style: a } = t;
    l && !re(l) && (t.class = vt(l)), Q(a) && (To(a) && !k(a) && (a = ne({}, a)), t.style = _e(a));
  }
  const i = re(e) ? 1 : Rn(e) ? 128 : fl(e) ? 64 : Q(e) ? 4 : $(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && i & 4 && To(e) && (e = F(e), D(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), M(
    e,
    t,
    o,
    s,
    r,
    i,
    n,
    !0
  );
}
function gc(e) {
  return e ? To(e) || On(e) ? ne({}, e) : e : null;
}
function wt(e, t, o = !1, s = !1) {
  const { props: r, ref: n, patchFlag: i, children: l, transition: a } = e, p = t ? mc(r || {}, t) : r, d = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: p,
    key: p && Fn(p),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      o && n ? k(n) ? n.concat(Do(t)) : [n, Do(t)] : Do(t)
    ) : n,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && i === -1 && k(l) ? l.map(Hn) : l,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== le ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: a,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && wt(e.ssContent),
    ssFallback: e.ssFallback && wt(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return a && s && js(
    d,
    a.clone(d)
  ), d;
}
function Hn(e) {
  const t = wt(e);
  return k(e.children) && (t.children = e.children.map(Hn)), t;
}
function Ln(e = " ", t = 0) {
  return Re(ho, null, e, t);
}
function me(e = "", t = !1) {
  return t ? (K(), Es(Ce, null, e)) : Re(Ce, null, e);
}
function Ue(e) {
  return e == null || typeof e == "boolean" ? Re(Ce) : k(e) ? Re(
    le,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : go(e) ? bt(e) : Re(ho, null, String(e));
}
function bt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : wt(e);
}
function Us(e, t) {
  let o = 0;
  const { shapeFlag: s } = e;
  if (t == null)
    t = null;
  else if (k(t))
    o = 16;
  else if (typeof t == "object")
    if (s & 65) {
      const r = t.default;
      r && (r._c && (r._d = !1), Us(e, r()), r._c && (r._d = !0));
      return;
    } else {
      o = 32;
      const r = t._;
      !r && !On(t) ? t._ctx = de : r === 3 && de && (de.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else $(t) ? (t = { default: t, _ctx: de }, o = 32) : (t = String(t), s & 64 ? (o = 16, t = [Ln(t)]) : o = 8);
  e.children = t, e.shapeFlag |= o;
}
function mc(...e) {
  const t = {};
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    for (const r in s)
      if (r === "class")
        t.class !== s.class && (t.class = vt([t.class, s.class]));
      else if (r === "style")
        t.style = _e([t.style, s.style]);
      else if (ao(r)) {
        const n = t[r], i = s[r];
        i && n !== i && !(k(n) && n.includes(i)) && (t[r] = n ? [].concat(n, i) : i);
      } else r !== "" && (t[r] = s[r]);
  }
  return t;
}
function Xe(e, t, o, s = null) {
  st(e, t, 7, [
    o,
    s
  ]);
}
const bc = wn();
let vc = 0;
function _c(e, t, o) {
  const s = e.type, r = (t ? t.appContext : e.appContext) || bc, n = {
    uid: vc++,
    vnode: e,
    type: s,
    parent: t,
    appContext: r,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new gi(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(r.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Vn(s, r),
    emitsOptions: $n(s, r),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: J,
    // inheritAttrs
    inheritAttrs: s.inheritAttrs,
    // state
    ctx: J,
    data: J,
    props: J,
    attrs: J,
    slots: J,
    refs: J,
    setupState: J,
    setupContext: null,
    // suspense related
    suspense: o,
    suspenseId: o ? o.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? n.ctx = Sl(n) : n.ctx = { _: n }, n.root = t ? t.root : n, n.emit = lc.bind(null, n), e.ce && e.ce(n), n;
}
let he = null;
const yc = () => he || de;
let Fo, xs;
{
  const e = uo(), t = (o, s) => {
    let r;
    return (r = e[o]) || (r = e[o] = []), r.push(s), (n) => {
      r.length > 1 ? r.forEach((i) => i(n)) : r[0](n);
    };
  };
  Fo = t(
    "__VUE_INSTANCE_SETTERS__",
    (o) => he = o
  ), xs = t(
    "__VUE_SSR_SETTERS__",
    (o) => co = o
  );
}
const mo = (e) => {
  const t = he;
  return Fo(e), e.scope.on(), () => {
    e.scope.off(), Fo(t);
  };
}, dr = () => {
  he && he.scope.off(), Fo(null);
}, wc = /* @__PURE__ */ ct("slot,component");
function Ns(e, { isNativeTag: t }) {
  (wc(e) || t(e)) && D(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function Un(e) {
  return e.vnode.shapeFlag & 4;
}
let co = !1;
function Ec(e, t = !1, o = !1) {
  t && xs(t);
  const { props: s, children: r } = e.vnode, n = Un(e);
  Fl(e, s, n, t), Yl(e, r, o);
  const i = n ? xc(e, t) : void 0;
  return t && xs(!1), i;
}
function xc(e, t) {
  var o;
  const s = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (s.name && Ns(s.name, e.appContext.config), s.components) {
      const n = Object.keys(s.components);
      for (let i = 0; i < n.length; i++)
        Ns(n[i], e.appContext.config);
    }
    if (s.directives) {
      const n = Object.keys(s.directives);
      for (let i = 0; i < n.length; i++)
        pn(n[i]);
    }
    s.compilerOptions && Nc() && D(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, vn), process.env.NODE_ENV !== "production" && Cl(e);
  const { setup: r } = s;
  if (r) {
    ut();
    const n = e.setupContext = r.length > 1 ? Dc(e) : null, i = mo(e), l = Ut(
      r,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? et(e.props) : e.props,
        n
      ]
    ), a = Vs(l);
    if (ft(), i(), (a || e.sp) && !zt(e) && hn(e), a) {
      if (l.then(dr, dr), t)
        return l.then((p) => {
          pr(e, p, t);
        }).catch((p) => {
          fo(p, e, 0);
        });
      if (e.asyncDep = l, process.env.NODE_ENV !== "production" && !e.suspense) {
        const p = (o = s.name) != null ? o : "Anonymous";
        D(
          `Component <${p}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      pr(e, l, t);
  } else
    Bn(e, t);
}
function pr(e, t, o) {
  $(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : Q(t) ? (process.env.NODE_ENV !== "production" && go(t) && D(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = Zr(t), process.env.NODE_ENV !== "production" && Tl(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && D(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), Bn(e, o);
}
const Nc = () => !0;
function Bn(e, t, o) {
  const s = e.type;
  e.render || (e.render = s.render || fe);
  {
    const r = mo(e);
    ut();
    try {
      Il(e);
    } finally {
      ft(), r();
    }
  }
  process.env.NODE_ENV !== "production" && !s.render && e.render === fe && !t && (s.template ? D(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : D("Component is missing template or render function: ", s));
}
const hr = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return jo(), ue(e, "get", ""), e[t];
  },
  set() {
    return D("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return D("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return ue(e, "get", ""), e[t];
  }
};
function Oc(e) {
  return new Proxy(e.slots, {
    get(t, o) {
      return ue(e, "get", "$slots"), t[o];
    }
  });
}
function Dc(e) {
  const t = (o) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && D("expose() should be called only once per setup()."), o != null)) {
      let s = typeof o;
      s === "object" && (k(o) ? s = "array" : ae(o) && (s = "ref")), s !== "object" && D(
        `expose() should be passed a plain object, received ${s}.`
      );
    }
    e.exposed = o || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let o, s;
    return Object.freeze({
      get attrs() {
        return o || (o = new Proxy(e.attrs, hr));
      },
      get slots() {
        return s || (s = Oc(e));
      },
      get emit() {
        return (r, ...n) => e.emit(r, ...n);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, hr),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function Qo(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Zr(Mi(e.exposed)), {
    get(t, o) {
      if (o in t)
        return t[o];
      if (o in Tt)
        return Tt[o](e);
    },
    has(t, o) {
      return o in t || o in Tt;
    }
  })) : e.proxy;
}
const Vc = /(?:^|[-_])(\w)/g, Sc = (e) => e.replace(Vc, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function Wn(e, t = !0) {
  return $(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Zo(e, t, o = !1) {
  let s = Wn(t);
  if (!s && t.__file) {
    const r = t.__file.match(/([^/\\]+)\.\w+$/);
    r && (s = r[1]);
  }
  if (!s && e && e.parent) {
    const r = (n) => {
      for (const i in n)
        if (n[i] === t)
          return i;
    };
    s = r(
      e.components || e.parent.type.components
    ) || r(e.appContext.components);
  }
  return s ? Sc(s) : o ? "App" : "Anonymous";
}
function Kn(e) {
  return $(e) && "__vccOpts" in e;
}
const Fe = (e, t) => {
  const o = Hi(e, t, co);
  if (process.env.NODE_ENV !== "production") {
    const s = yc();
    s && s.appContext.config.warnRecursiveComputed && (o._warnRecursive = !0);
  }
  return o;
};
function Cc() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, o = { style: "color:#f5222d" }, s = { style: "color:#eb2f96" }, r = {
    __vue_custom_formatter: !0,
    header(f) {
      return Q(f) ? f.__isVue ? ["div", e, "VueInstance"] : ae(f) ? [
        "div",
        {},
        ["span", e, d(f)],
        "<",
        // avoid debugger accessing value affecting behavior
        l("_value" in f ? f._value : f),
        ">"
      ] : St(f) ? [
        "div",
        {},
        ["span", e, Oe(f) ? "ShallowReactive" : "Reactive"],
        "<",
        l(f),
        `>${lt(f) ? " (readonly)" : ""}`
      ] : lt(f) ? [
        "div",
        {},
        ["span", e, Oe(f) ? "ShallowReadonly" : "Readonly"],
        "<",
        l(f),
        ">"
      ] : null : null;
    },
    hasBody(f) {
      return f && f.__isVue;
    },
    body(f) {
      if (f && f.__isVue)
        return [
          "div",
          {},
          ...n(f.$)
        ];
    }
  };
  function n(f) {
    const m = [];
    f.type.props && f.props && m.push(i("props", F(f.props))), f.setupState !== J && m.push(i("setup", f.setupState)), f.data !== J && m.push(i("data", F(f.data)));
    const V = a(f, "computed");
    V && m.push(i("computed", V));
    const E = a(f, "inject");
    return E && m.push(i("injected", E)), m.push([
      "div",
      {},
      [
        "span",
        {
          style: s.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: f }]
    ]), m;
  }
  function i(f, m) {
    return m = ne({}, m), Object.keys(m).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        f
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(m).map((V) => [
          "div",
          {},
          ["span", s, V + ": "],
          l(m[V], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function l(f, m = !0) {
    return typeof f == "number" ? ["span", t, f] : typeof f == "string" ? ["span", o, JSON.stringify(f)] : typeof f == "boolean" ? ["span", s, f] : Q(f) ? ["object", { object: m ? F(f) : f }] : ["span", o, String(f)];
  }
  function a(f, m) {
    const V = f.type;
    if ($(V))
      return;
    const E = {};
    for (const j in f.ctx)
      p(V, j, m) && (E[j] = f.ctx[j]);
    return E;
  }
  function p(f, m, V) {
    const E = f[V];
    if (k(E) && E.includes(m) || Q(E) && m in E || f.extends && p(f.extends, m, V) || f.mixins && f.mixins.some((j) => p(j, m, V)))
      return !0;
  }
  function d(f) {
    return Oe(f) ? "ShallowRef" : f.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(r) : window.devtoolsFormatters = [r];
}
const gr = "3.5.13", ze = process.env.NODE_ENV !== "production" ? D : fe;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Os;
const mr = typeof window < "u" && window.trustedTypes;
if (mr)
  try {
    Os = /* @__PURE__ */ mr.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && ze(`Error creating trusted types policy: ${e}`);
  }
const qn = Os ? (e) => Os.createHTML(e) : (e) => e, Tc = "http://www.w3.org/2000/svg", Ac = "http://www.w3.org/1998/Math/MathML", nt = typeof document < "u" ? document : null, br = nt && /* @__PURE__ */ nt.createElement("template"), Ic = {
  insert: (e, t, o) => {
    t.insertBefore(e, o || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, o, s) => {
    const r = t === "svg" ? nt.createElementNS(Tc, e) : t === "mathml" ? nt.createElementNS(Ac, e) : o ? nt.createElement(e, { is: o }) : nt.createElement(e);
    return e === "select" && s && s.multiple != null && r.setAttribute("multiple", s.multiple), r;
  },
  createText: (e) => nt.createTextNode(e),
  createComment: (e) => nt.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => nt.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, o, s, r, n) {
    const i = o ? o.previousSibling : t.lastChild;
    if (r && (r === n || r.nextSibling))
      for (; t.insertBefore(r.cloneNode(!0), o), !(r === n || !(r = r.nextSibling)); )
        ;
    else {
      br.innerHTML = qn(
        s === "svg" ? `<svg>${e}</svg>` : s === "mathml" ? `<math>${e}</math>` : e
      );
      const l = br.content;
      if (s === "svg" || s === "mathml") {
        const a = l.firstChild;
        for (; a.firstChild; )
          l.appendChild(a.firstChild);
        l.removeChild(a);
      }
      t.insertBefore(l, o);
    }
    return [
      // first
      i ? i.nextSibling : t.firstChild,
      // last
      o ? o.previousSibling : t.lastChild
    ];
  }
}, kc = Symbol("_vtc");
function Pc(e, t, o) {
  const s = e[kc];
  s && (t = (t ? [t, ...s] : [...s]).join(" ")), t == null ? e.removeAttribute("class") : o ? e.setAttribute("class", t) : e.className = t;
}
const zo = Symbol("_vod"), Gn = Symbol("_vsh"), Jn = {
  beforeMount(e, { value: t }, { transition: o }) {
    e[zo] = e.style.display === "none" ? "" : e.style.display, o && t ? o.beforeEnter(e) : Xt(e, t);
  },
  mounted(e, { value: t }, { transition: o }) {
    o && t && o.enter(e);
  },
  updated(e, { value: t, oldValue: o }, { transition: s }) {
    !t != !o && (s ? t ? (s.beforeEnter(e), Xt(e, !0), s.enter(e)) : s.leave(e, () => {
      Xt(e, !1);
    }) : Xt(e, t));
  },
  beforeUnmount(e, { value: t }) {
    Xt(e, t);
  }
};
process.env.NODE_ENV !== "production" && (Jn.name = "show");
function Xt(e, t) {
  e.style.display = t ? e[zo] : "none", e[Gn] = !t;
}
const $c = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), Mc = /(^|;)\s*display\s*:/;
function Rc(e, t, o) {
  const s = e.style, r = re(o);
  let n = !1;
  if (o && !r) {
    if (t)
      if (re(t))
        for (const i of t.split(";")) {
          const l = i.slice(0, i.indexOf(":")).trim();
          o[l] == null && Vo(s, l, "");
        }
      else
        for (const i in t)
          o[i] == null && Vo(s, i, "");
    for (const i in o)
      i === "display" && (n = !0), Vo(s, i, o[i]);
  } else if (r) {
    if (t !== o) {
      const i = s[$c];
      i && (o += ";" + i), s.cssText = o, n = Mc.test(o);
    }
  } else t && e.removeAttribute("style");
  zo in e && (e[zo] = n ? s.display : "", e[Gn] && (s.display = "none"));
}
const jc = /[^\\];\s*$/, vr = /\s*!important$/;
function Vo(e, t, o) {
  if (k(o))
    o.forEach((s) => Vo(e, t, s));
  else if (o == null && (o = ""), process.env.NODE_ENV !== "production" && jc.test(o) && ze(
    `Unexpected semicolon at the end of '${t}' style value: '${o}'`
  ), t.startsWith("--"))
    e.setProperty(t, o);
  else {
    const s = Fc(e, t);
    vr.test(o) ? e.setProperty(
      $e(s),
      o.replace(vr, ""),
      "important"
    ) : e[s] = o;
  }
}
const _r = ["Webkit", "Moz", "ms"], cs = {};
function Fc(e, t) {
  const o = cs[t];
  if (o)
    return o;
  let s = Se(t);
  if (s !== "filter" && s in e)
    return cs[t] = s;
  s = Bo(s);
  for (let r = 0; r < _r.length; r++) {
    const n = _r[r] + s;
    if (n in e)
      return cs[t] = n;
  }
  return t;
}
const yr = "http://www.w3.org/1999/xlink";
function wr(e, t, o, s, r, n = hi(t)) {
  s && t.startsWith("xlink:") ? o == null ? e.removeAttributeNS(yr, t.slice(6, t.length)) : e.setAttributeNS(yr, t, o) : o == null || n && !Ir(o) ? e.removeAttribute(t) : e.setAttribute(
    t,
    n ? "" : at(o) ? String(o) : o
  );
}
function Er(e, t, o, s, r) {
  if (t === "innerHTML" || t === "textContent") {
    o != null && (e[t] = t === "innerHTML" ? qn(o) : o);
    return;
  }
  const n = e.tagName;
  if (t === "value" && n !== "PROGRESS" && // custom elements may use _value internally
  !n.includes("-")) {
    const l = n === "OPTION" ? e.getAttribute("value") || "" : e.value, a = o == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(o);
    (l !== a || !("_value" in e)) && (e.value = a), o == null && e.removeAttribute(t), e._value = o;
    return;
  }
  let i = !1;
  if (o === "" || o == null) {
    const l = typeof e[t];
    l === "boolean" ? o = Ir(o) : o == null && l === "string" ? (o = "", i = !0) : l === "number" && (o = 0, i = !0);
  }
  try {
    e[t] = o;
  } catch (l) {
    process.env.NODE_ENV !== "production" && !i && ze(
      `Failed setting prop "${t}" on <${n.toLowerCase()}>: value ${o} is invalid.`,
      l
    );
  }
  i && e.removeAttribute(r || t);
}
function zc(e, t, o, s) {
  e.addEventListener(t, o, s);
}
function Hc(e, t, o, s) {
  e.removeEventListener(t, o, s);
}
const xr = Symbol("_vei");
function Lc(e, t, o, s, r = null) {
  const n = e[xr] || (e[xr] = {}), i = n[t];
  if (s && i)
    i.value = process.env.NODE_ENV !== "production" ? Or(s, t) : s;
  else {
    const [l, a] = Uc(t);
    if (s) {
      const p = n[t] = Kc(
        process.env.NODE_ENV !== "production" ? Or(s, t) : s,
        r
      );
      zc(e, l, p, a);
    } else i && (Hc(e, l, i, a), n[t] = void 0);
  }
}
const Nr = /(?:Once|Passive|Capture)$/;
function Uc(e) {
  let t;
  if (Nr.test(e)) {
    t = {};
    let s;
    for (; s = e.match(Nr); )
      e = e.slice(0, e.length - s[0].length), t[s[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : $e(e.slice(2)), t];
}
let as = 0;
const Bc = /* @__PURE__ */ Promise.resolve(), Wc = () => as || (Bc.then(() => as = 0), as = Date.now());
function Kc(e, t) {
  const o = (s) => {
    if (!s._vts)
      s._vts = Date.now();
    else if (s._vts <= o.attached)
      return;
    st(
      qc(s, o.value),
      t,
      5,
      [s]
    );
  };
  return o.value = e, o.attached = Wc(), o;
}
function Or(e, t) {
  return $(e) || k(e) ? e : (ze(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), fe);
}
function qc(e, t) {
  if (k(t)) {
    const o = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      o.call(e), e._stopped = !0;
    }, t.map(
      (s) => (r) => !r._stopped && s && s(r)
    );
  } else
    return t;
}
const Dr = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Gc = (e, t, o, s, r, n) => {
  const i = r === "svg";
  t === "class" ? Pc(e, s, i) : t === "style" ? Rc(e, o, s) : ao(t) ? So(t) || Lc(e, t, o, s, n) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Jc(e, t, s, i)) ? (Er(e, t, s), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && wr(e, t, s, i, n, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !re(s)) ? Er(e, Se(t), s, n, t) : (t === "true-value" ? e._trueValue = s : t === "false-value" && (e._falseValue = s), wr(e, t, s, i));
};
function Jc(e, t, o, s) {
  if (s)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Dr(t) && $(o));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const r = e.tagName;
    if (r === "IMG" || r === "VIDEO" || r === "CANVAS" || r === "SOURCE")
      return !1;
  }
  return Dr(t) && re(o) ? !1 : t in e;
}
const Vr = {};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Yc(e, t, o) {
  const s = /* @__PURE__ */ dl(e, t);
  Lo(s) && ne(s, t);
  class r extends Bs {
    constructor(i) {
      super(s, i, o);
    }
  }
  return r.def = s, r;
}
const Xc = typeof HTMLElement < "u" ? HTMLElement : class {
};
class Bs extends Xc {
  constructor(t, o = {}, s = Cr) {
    super(), this._def = t, this._props = o, this._createApp = s, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && s !== Cr ? this._root = this.shadowRoot : (process.env.NODE_ENV !== "production" && this.shadowRoot && ze(
      "Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`."
    ), t.shadowRoot !== !1 ? (this.attachShadow({ mode: "open" }), this._root = this.shadowRoot) : this._root = this), this._def.__asyncLoader || this._resolveProps(this._def);
  }
  connectedCallback() {
    if (!this.isConnected) return;
    this.shadowRoot || this._parseSlots(), this._connected = !0;
    let t = this;
    for (; t = t && (t.parentNode || t.host); )
      if (t instanceof Bs) {
        this._parent = t;
        break;
      }
    this._instance || (this._resolved ? (this._setParent(), this._update()) : t && t._pendingResolve ? this._pendingResolve = t._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(t = this._parent) {
    t && (this._instance.parent = t._instance, this._instance.provides = t._instance.provides);
  }
  disconnectedCallback() {
    this._connected = !1, on(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let s = 0; s < this.attributes.length; s++)
      this._setAttr(this.attributes[s].name);
    this._ob = new MutationObserver((s) => {
      for (const r of s)
        this._setAttr(r.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (s, r = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: n, styles: i } = s;
      let l;
      if (n && !k(n))
        for (const a in n) {
          const p = n[a];
          (p === Number || p && p.type === Number) && (a in this._props && (this._props[a] = qs(this._props[a])), (l || (l = /* @__PURE__ */ Object.create(null)))[Se(a)] = !0);
        }
      this._numberProps = l, r && this._resolveProps(s), this.shadowRoot ? this._applyStyles(i) : process.env.NODE_ENV !== "production" && i && ze(
        "Custom element style injection is not supported when using shadowRoot: false"
      ), this._mount(s);
    }, o = this._def.__asyncLoader;
    o ? this._pendingResolve = o().then(
      (s) => t(this._def = s, !0)
    ) : t(this._def);
  }
  _mount(t) {
    process.env.NODE_ENV !== "production" && !t.name && (t.name = "VueElement"), this._app = this._createApp(t), t.configureApp && t.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const o = this._instance && this._instance.exposed;
    if (o)
      for (const s in o)
        B(this, s) ? process.env.NODE_ENV !== "production" && ze(`Exposed property "${s}" already exists on custom element.`) : Object.defineProperty(this, s, {
          // unwrap ref to be consistent with public instance behavior
          get: () => Qr(o[s])
        });
  }
  _resolveProps(t) {
    const { props: o } = t, s = k(o) ? o : Object.keys(o || {});
    for (const r of Object.keys(this))
      r[0] !== "_" && s.includes(r) && this._setProp(r, this[r]);
    for (const r of s.map(Se))
      Object.defineProperty(this, r, {
        get() {
          return this._getProp(r);
        },
        set(n) {
          this._setProp(r, n, !0, !0);
        }
      });
  }
  _setAttr(t) {
    if (t.startsWith("data-v-")) return;
    const o = this.hasAttribute(t);
    let s = o ? this.getAttribute(t) : Vr;
    const r = Se(t);
    o && this._numberProps && this._numberProps[r] && (s = qs(s)), this._setProp(r, s, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, o, s = !0, r = !1) {
    if (o !== this._props[t] && (o === Vr ? delete this._props[t] : (this._props[t] = o, t === "key" && this._app && (this._app._ceVNode.key = o)), r && this._instance && this._update(), s)) {
      const n = this._ob;
      n && n.disconnect(), o === !0 ? this.setAttribute($e(t), "") : typeof o == "string" || typeof o == "number" ? this.setAttribute($e(t), o + "") : o || this.removeAttribute($e(t)), n && n.observe(this, { attributes: !0 });
    }
  }
  _update() {
    Zc(this._createVNode(), this._root);
  }
  _createVNode() {
    const t = {};
    this.shadowRoot || (t.onVnodeMounted = t.onVnodeUpdated = this._renderSlots.bind(this));
    const o = Re(this._def, ne(t, this._props));
    return this._instance || (o.ce = (s) => {
      this._instance = s, s.ce = this, s.isCE = !0, process.env.NODE_ENV !== "production" && (s.ceReload = (n) => {
        this._styles && (this._styles.forEach((i) => this._root.removeChild(i)), this._styles.length = 0), this._applyStyles(n), this._instance = null, this._update();
      });
      const r = (n, i) => {
        this.dispatchEvent(
          new CustomEvent(
            n,
            Lo(i[0]) ? ne({ detail: i }, i[0]) : { detail: i }
          )
        );
      };
      s.emit = (n, ...i) => {
        r(n, i), $e(n) !== n && r($e(n), i);
      }, this._setParent();
    }), o;
  }
  _applyStyles(t, o) {
    if (!t) return;
    if (o) {
      if (o === this._def || this._styleChildren.has(o))
        return;
      this._styleChildren.add(o);
    }
    const s = this._nonce;
    for (let r = t.length - 1; r >= 0; r--) {
      const n = document.createElement("style");
      if (s && n.setAttribute("nonce", s), n.textContent = t[r], this.shadowRoot.prepend(n), process.env.NODE_ENV !== "production")
        if (o) {
          if (o.__hmrId) {
            this._childStyles || (this._childStyles = /* @__PURE__ */ new Map());
            let i = this._childStyles.get(o.__hmrId);
            i || this._childStyles.set(o.__hmrId, i = []), i.push(n);
          }
        } else
          (this._styles || (this._styles = [])).push(n);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const t = this._slots = {};
    let o;
    for (; o = this.firstChild; ) {
      const s = o.nodeType === 1 && o.getAttribute("slot") || "default";
      (t[s] || (t[s] = [])).push(o), this.removeChild(o);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const t = (this._teleportTarget || this).querySelectorAll("slot"), o = this._instance.type.__scopeId;
    for (let s = 0; s < t.length; s++) {
      const r = t[s], n = r.getAttribute("name") || "default", i = this._slots[n], l = r.parentNode;
      if (i)
        for (const a of i) {
          if (o && a.nodeType === 1) {
            const p = o + "-s", d = document.createTreeWalker(a, 1);
            a.setAttribute(p, "");
            let f;
            for (; f = d.nextNode(); )
              f.setAttribute(p, "");
          }
          l.insertBefore(a, r);
        }
      else
        for (; r.firstChild; ) l.insertBefore(r.firstChild, r);
      l.removeChild(r);
    }
  }
  /**
   * @internal
   */
  _injectChildStyle(t) {
    this._applyStyles(t.styles, t);
  }
  /**
   * @internal
   */
  _removeChildStyle(t) {
    if (process.env.NODE_ENV !== "production" && (this._styleChildren.delete(t), this._childStyles && t.__hmrId)) {
      const o = this._childStyles.get(t.__hmrId);
      o && (o.forEach((s) => this._root.removeChild(s)), o.length = 0);
    }
  }
}
const Qc = /* @__PURE__ */ ne({ patchProp: Gc }, Ic);
let Sr;
function Yn() {
  return Sr || (Sr = Zl(Qc));
}
const Zc = (...e) => {
  Yn().render(...e);
}, Cr = (...e) => {
  const t = Yn().createApp(...e);
  process.env.NODE_ENV !== "production" && (ta(t), oa(t));
  const { mount: o } = t;
  return t.mount = (s) => {
    const r = sa(s);
    if (!r) return;
    const n = t._component;
    !$(n) && !n.render && !n.template && (n.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
    const i = o(r, !1, ea(r));
    return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), i;
  }, t;
};
function ea(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function ta(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => ui(t) || fi(t) || di(t),
    writable: !1
  });
}
function oa(e) {
  {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        ze(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const o = e.config.compilerOptions, s = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return ze(s), o;
      },
      set() {
        ze(s);
      }
    });
  }
}
function sa(e) {
  if (re(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && ze(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && ze(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function ra() {
  Cc();
}
process.env.NODE_ENV !== "production" && ra();
const na = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [s, r] of t)
    o[s] = r;
  return o;
}, ia = {
  key: 0,
  class: "fixed inset-0 z-[999] flex items-center justify-center"
}, la = { class: "bg-white p-6 rounded-lg shadow-xl relative max-w-md mx-auto" }, ca = { class: "text-xl font-bold mb-4 text-gray-800" }, aa = { class: "text-gray-700 mb-6" }, ua = {
  __name: "InfoPopup",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: "Information"
    },
    message: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const o = e, s = t;
    function r() {
      s("update:modelValue", !1);
    }
    return Lt(() => o.modelValue, (n) => {
      console.log("InfoPopup: modelValue changed to:", n);
    }), console.log("InfoPopup component setup. Initial modelValue:", o.modelValue), (n, i) => e.modelValue ? (K(), X("div", ia, [
      M("div", {
        class: "absolute inset-0 bg-black opacity-50",
        onClick: r
      }),
      M("div", la, [
        M("h3", ca, ce(e.title), 1),
        M("p", aa, ce(e.message), 1),
        M("div", { class: "flex justify-end" }, [
          M("button", {
            onClick: r,
            class: "px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-200"
          }, " OK ")
        ])
      ])
    ])) : me("", !0);
  }
}, fa = {
  __name: "MyPortal",
  setup(e) {
    return (t, o) => Vl(t.$slots, "default");
  }
};
function da(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch (t) {
    return console.log("error in cloneMe: " + t.message), console.trace(), e;
  }
}
const pa = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{top:0;right:0;bottom:0;left:0}.right-4{right:1rem}.top-4{top:1rem}.z-\\[90\\]{z-index:90}.z-\\[999\\]{z-index:999}.mx-auto{margin-left:auto;margin-right:auto}.mb-2{margin-bottom:.5rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-6{margin-bottom:1.5rem}.ml-10{margin-left:2.5rem}.mr-1{margin-right:.25rem}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-4{margin-top:1rem}.mt-6{margin-top:1.5rem}.flex{display:flex}.grid{display:grid}.hidden{display:none}.h-10{height:2.5rem}.h-5{height:1.25rem}.h-56{height:14rem}.h-6{height:1.5rem}.h-full{height:100%}.max-h-\\[100\\%\\]{max-height:100%}.w-10{width:2.5rem}.w-5{width:1.25rem}.w-6{width:1.5rem}.w-full{width:100%}.max-w-md{max-width:28rem}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.rotate-180{--tw-rotate: 180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-pointer{cursor:pointer}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.items-center{align-items:center}.items-baseline{align-items:baseline}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-6{gap:1.5rem}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * calc(1 - var(--tw-space-x-reverse)))}.space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem * var(--tw-space-y-reverse))}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.rounded-2xl{border-radius:1rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-xl{border-radius:.75rem}.border{border-width:1px}.border-t{border-top-width:1px}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229 231 235 / var(--tw-border-opacity, 1))}.border-gray-400{--tw-border-opacity: 1;border-color:rgb(156 163 175 / var(--tw-border-opacity, 1))}.bg-black{--tw-bg-opacity: 1;background-color:rgb(0 0 0 / var(--tw-bg-opacity, 1))}.bg-gray-50{--tw-bg-opacity: 1;background-color:rgb(249 250 251 / var(--tw-bg-opacity, 1))}.bg-indigo-600{--tw-bg-opacity: 1;background-color:rgb(79 70 229 / var(--tw-bg-opacity, 1))}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.object-cover{-o-object-fit:cover;object-fit:cover}.p-4{padding:1rem}.p-6{padding:1.5rem}.p-8{padding:2rem}.px-4{padding-left:1rem;padding-right:1rem}.px-8{padding-left:2rem;padding-right:2rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-0{padding-bottom:0}.pb-6{padding-bottom:1.5rem}.text-left{text-align:left}.text-center{text-align:center}.text-2xl{font-size:1.5rem;line-height:2rem}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.text-gray-500{--tw-text-opacity: 1;color:rgb(107 114 128 / var(--tw-text-opacity, 1))}.text-gray-600{--tw-text-opacity: 1;color:rgb(75 85 99 / var(--tw-text-opacity, 1))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.text-gray-800{--tw-text-opacity: 1;color:rgb(31 41 55 / var(--tw-text-opacity, 1))}.text-red-500{--tw-text-opacity: 1;color:rgb(239 68 68 / var(--tw-text-opacity, 1))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.line-through{text-decoration-line:line-through}.opacity-50{opacity:.5}.shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-xl{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-200{transition-duration:.2s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.optionImage{width:122px;height:122px}.layout-grid{min-height:100px;min-width:75vw;width:calc(100% - 50px);max-height:92vh;overflow:hidden;display:grid;grid-template-rows:auto minmax(0,1fr) min-content;gap:var(--gap);margin:0 25px}.item-additionals .description{color:#4b5563}.quantity-button{display:flex;height:2.5rem;width:2.5rem;align-items:center;justify-content:center;border-radius:9999px;font-size:1.25rem;line-height:1.75rem;font-weight:700;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);background-color:#e2e8f0;color:#475569;box-shadow:0 2px 4px #0000000d}.quantity-button:hover{background-color:#cbd5e1}.quantity-button.increment:hover{filter:brightness(.85)}.add-to-cart-button{border-radius:9999px;padding:.75rem 2rem;font-size:1.125rem;line-height:1.75rem;font-weight:700;--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow);transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.add-to-cart-button:hover{filter:brightness(.85)}.accordion-item{background-color:#fff}.accordion-header{cursor:pointer}.options-grid{grid-template-columns:repeat(auto-fill,minmax(200px,1fr))}.hover\\:bg-gray-100:hover{--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity, 1))}.hover\\:bg-gray-50:hover{--tw-bg-opacity: 1;background-color:rgb(249 250 251 / var(--tw-bg-opacity, 1))}.hover\\:bg-indigo-700:hover{--tw-bg-opacity: 1;background-color:rgb(67 56 202 / var(--tw-bg-opacity, 1))}.hover\\:text-gray-700:hover{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus\\:ring-primary:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(158 127 255 / var(--tw-ring-opacity, 1))}.focus\\:ring-opacity-50:focus{--tw-ring-opacity: .5}@media (min-width: 640px){.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}}@media (min-width: 768px){.md\\:w-2\\/5{width:40%}.md\\:flex-row{flex-direction:row}}@media (min-width: 1024px){.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}}', ha = { class: "layout-grid bg-white rounded-2xl shadow-md relative" }, ga = { class: "grid-top" }, ma = { class: "relative p-8 pb-0" }, ba = { class: "flex flex-col md:flex-row items-start gap-6 mb-6" }, va = {
  key: 0,
  class: "flex-shrink-0 w-full md:w-2/5 h-56"
}, _a = ["src", "alt"], ya = { class: "flex-grow" }, wa = { class: "text-3xl font-bold text-gray-800" }, Ea = ["innerHTML"], xa = {
  key: 0,
  class: "text-sm text-gray-500 mt-2"
}, Na = {
  key: 1,
  class: "price-display mt-4 flex items-baseline gap-2"
}, Oa = {
  key: 0,
  class: "text-xl font-semibold text-gray-600 mr-1"
}, Da = {
  key: 1,
  class: "text-xl text-gray-500 line-through"
}, Va = {
  key: 0,
  class: "size-selection mt-6"
}, Sa = { class: "grid grid-cols-2 sm:grid-cols-3 gap-3" }, Ca = ["onClick"], Ta = {
  key: 1,
  class: "replace-article-variants-section mt-6"
}, Aa = { class: "text-lg font-semibold text-gray-700 mb-3" }, Ia = { class: "grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6" }, ka = ["onClick"], Pa = ["src", "alt"], $a = { class: "w-full" }, Ma = { class: "grid-middle p-8 pb-0" }, Ra = { class: "item-additionals scrollable-area max-h-[100%] overflow-y-auto w-full mx-auto relative pb-6" }, ja = {
  key: 0,
  class: "variants-accordion space-y-6"
}, Fa = {
  key: 0,
  class: "accordion-item border border-gray-400 rounded-lg overflow-hidden"
}, za = ["onClick"], Ha = { class: "flex flex-col" }, La = {
  key: 0,
  class: "text-sm font-normal text-gray-500 mt-1"
}, Ua = { class: "accordion-content p-4" }, Ba = { class: "options-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" }, Wa = ["onClick"], Ka = ["src", "alt"], qa = { class: "w-full" }, Ga = { class: "grid-bottom" }, Ja = { class: "add-to-cart-section px-8 py-4 border-t border-gray-200 flex items-center justify-between" }, Ya = { class: "flex items-center space-x-4" }, Xa = { class: "text-2xl font-bold text-gray-800" }, Qa = {
  __name: "WcApp",
  props: {
    article: {
      type: String,
      default: ""
    },
    items: {
      type: String,
      default: "[]"
    },
    title: {
      type: String,
      default: "title"
    },
    primaryColor: {
      // New prop for primary button color
      type: String,
      default: "#FFFFFF"
      // Default to the existing primary color from your palette
    },
    itemType: {
      type: String,
      default: "foodOrder"
    }
  },
  emits: ["close-additionals", "click-image", "add-to-cart"],
  setup(e, { emit: t }) {
    const o = t, s = Pt(!1), r = Pt(""), n = Pt(""), i = (g, x, b) => {
      r.value = g, n.value = x, s.value = b;
    };
    En("setPopup", i);
    const l = e, a = qo({}), p = Pt(1), d = Pt(null), f = Pt([]), m = (g) => !g || !Array.isArray(g.options) ? [] : g.options.filter((x) => x && typeof x == "object" && x.active !== !1), V = (g) => {
      var x;
      console.log("initializeSelections...");
      for (const b in a)
        delete a[b];
      g && g.extras && g.extras.variants && g.extras.variants.forEach((b) => {
        const T = Array.isArray(b.options) ? b.options.filter((H) => H && typeof H == "object") : [];
        if (b.multi)
          a[b.title] = [];
        else {
          let H = null;
          !H && b.implicit && T.length > 0 && (H = T[0]), H ? a[b.title] = [H.id] : a[b.title] = [];
        }
      }), g && g.sizes && g.sizes.length > 0 ? d.value = g.sizes[0].vol : d.value = null, f.value = (((x = g.extras) == null ? void 0 : x.variants) || []).filter((b) => b.replaceArticle !== !0 && m(b).length > 0).map((b) => b.title);
    };
    Lt(() => l.article, (g) => {
      if (g && typeof g == "string" && g.trim() !== "")
        try {
          const x = JSON.parse(g);
          console.log("articleData", x), V(x);
        } catch (x) {
          console.error("Failed to parse article JSON:", x);
        }
      else
        console.warn("Received empty or invalid article prop, skipping JSON parsing.");
    }, { immediate: !0 });
    const E = Fe(() => {
      try {
        return JSON.parse(l.article);
      } catch {
        return {
          nameDE: "Burger#1",
          descriptionDE: "direkt vom BBQ-Grill und echtem Raucharoma",
          posId: "3406",
          sizes: [
            {
              vol: "300g",
              price: 11.5
            },
            {
              vol: "120g",
              price: 5.9
            }
          ],
          extras: {
            variants: [
              {
                // Beispiel für replaceArticle: true
                title: "Hauptgericht ersetzen",
                options: [
                  {
                    id: "replace-opt-1",
                    posId: "R1",
                    labelDE: "Großer Salat",
                    cost: 12,
                    imageUrl: "https://images.pexels.com/photos/1059905/pexels-photo-1059905.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  },
                  {
                    id: "replace-opt-2",
                    posId: "R2",
                    labelDE: "Veggie Bowl",
                    cost: 10.5,
                    imageUrl: "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !0,
                dropdown: !1,
                implicit: !1
              },
              {
                title: "Beispiel mit Implizit",
                options: [
                  {
                    id: "ia6vgda26kemhgg2fiu",
                    posId: "7347700000000002",
                    labelDE: "Pfand",
                    labelEN: "",
                    cost: 0.15,
                    articleNo: ""
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !1,
                dropdown: !1,
                implicit: !0
              },
              {
                title: "Min-Max Beispiel",
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                options: [
                  {
                    id: "aufvrlttbaamhgg9ihj",
                    posId: "4902",
                    labelDE: "Rinderstreifen",
                    cost: 6,
                    articleNo: ""
                  },
                  {
                    id: "e9p5jxa1bpvmhgg9ihj",
                    posId: "4903",
                    labelDE: "King Prawns",
                    cost: 7,
                    articleNo: ""
                  },
                  {
                    id: "5wdcmo5dgqsmhgg9ihj",
                    posId: "4904",
                    labelDE: "Hähnchenbrust",
                    cost: 5,
                    articleNo: ""
                  },
                  {
                    id: "6ksdkiit8tdmhgvdmb0",
                    posId: "89",
                    labelDE: "Portion Pommes Frites",
                    labelEN: "",
                    cost: 1.8,
                    articleNo: ""
                  },
                  {
                    id: "m3eset3ullmhgve1r8",
                    posId: "38",
                    labelDE: "Portion Kartoffelsalat mit Beilagen",
                    labelEN: "",
                    cost: 1.5,
                    articleNo: ""
                  }
                ],
                freeArticles: 2,
                maxOptions: 4
              },
              {
                title: "Salatbeilage",
                options: [
                  {
                    id: "76s5mc4rsa5mhgg6c9s",
                    posId: "850f3d2b-69a4-4584-836e-f8f17a19d709",
                    labelDE: "Pommes Frites",
                    labelEN: "",
                    cost: 0,
                    articleNo: ""
                  },
                  {
                    id: "qnu73ht3p5mhgg6evk",
                    posId: "62b81be3-8565-469a-8755-51d05acc9c05",
                    labelDE: "Vollkornbrot",
                    labelEN: "",
                    cost: 1,
                    articleNo: ""
                  }
                ],
                multi: !1,
                optional: !1,
                replaceArticle: !1,
                dropdown: !1,
                implicit: !1
              },
              {
                title: "Dynamische bei Pommes",
                options: [
                  {
                    id: "sjjxuw9hm5mhgg7yue",
                    posId: "3e56f167-aa33-470c-8c36-653e23bc9128",
                    labelDE: "Ketchup",
                    labelEN: "",
                    cost: 0.2,
                    articleNo: ""
                  }
                ],
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                trigger: "76s5mc4rsa5mhgg6c9s"
              },
              {
                title: "Extras?",
                multi: !0,
                replaceArticle: !1,
                dropdown: !1,
                options: [
                  {
                    id: "2lq3r4ugkavkprfevzy",
                    posId: "3410",
                    labelDE: "Extra Bacon",
                    cost: 1.5,
                    active: !1
                  },
                  {
                    id: "1od82o2vwfvkprfevzz",
                    posId: "3411",
                    labelDE: "Extra Käse",
                    cost: 1
                  }
                ]
              },
              {
                title: "Beilage",
                optional: !1,
                multi: !1,
                replaceArticle: !1,
                dropdown: !1,
                implicit: !1,
                options: [
                  {
                    id: "22tax9m87swkprfevzz",
                    posId: "4201",
                    labelDE: "Süßkartoffelpommes",
                    cost: 0
                  },
                  {
                    id: "cemjql7brokprfew00",
                    posId: "4202",
                    labelDE: "Pommes Frites",
                    cost: 0
                  },
                  {
                    id: "vd4ry514nqkprfevzz",
                    posId: "4204",
                    labelDE: "Curly Fries",
                    cost: 0
                  },
                  {
                    id: "zwzzqdwcxpkprfevzz",
                    posId: "4206",
                    labelDE: "Coleslaw",
                    cost: 0,
                    imageUrl: "https://file.qsignal.eu/demo1besttaste/images/foods/ajesh-tp-1633525.jpg",
                    substances: {
                      aA: !0,
                      aC: !0
                    }
                  },
                  {
                    id: "e1pboc1ga9kprfevzz",
                    posId: "4210",
                    labelDE: "Kroketten",
                    cost: 0
                  },
                  {
                    id: "2jsglzorfp5kprfevzz",
                    posId: "4213",
                    labelDE: "Beilagensalat",
                    cost: 0
                  }
                ]
              }
            ]
          },
          substances: {
            aA: !0,
            aE: !0,
            lBIO: !0,
            aC: !0,
            z3: !0,
            z4: !0
          },
          gramm: 0,
          image: "https://file.qsignal.eu/demo1besttaste/images/foods/ajesh-tp-1633525.jpg",
          moreImages: [],
          validStores: [],
          streichPreis: 20.99,
          neu: !0,
          days: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7"
          ]
        };
      }
    }), j = Fe(() => {
      var g, x;
      return ((x = (g = E.value) == null ? void 0 : g.extras) == null ? void 0 : x.variants) || [];
    }), te = Fe(
      () => j.value.filter((g) => g.replaceArticle === !0)
    ), q = Fe(
      () => j.value.filter((g) => g.replaceArticle !== !0)
    ), oe = {
      fPork: "Schweinefleisch",
      fBeef: "Rindfleisch",
      fOther: "Anderes Fleisch",
      aA: "Gluten",
      aB: "Krebstiere",
      aC: "Eier von Geflügel",
      aD: "Fisch",
      aE: "Erdnüsse",
      aF: "Sojabohnen",
      aG: "Milch und Milcherzeugnisse",
      aH: "Schalenfrüchte",
      aL: "Sellerie",
      aM: "Senf",
      aN: "Sesamen",
      aO: "Schwefeloxid und Sulfite",
      aP: "Lupinen",
      aR: "Weichtiere",
      z1: "Konservierungsstoff",
      z2: "Geschmacksverstärker",
      z3: "Antioxidationsmittel",
      z4: "Farbstoff",
      z5: "Phosphat",
      z6: "chininhaltig",
      z7: "koffeinhaltig",
      z8: "geschwefelt",
      z9: "Saccharin",
      z10: "Aspartam/ Phenylalaninquelle",
      z11: "Cyclamat",
      z12: "Acesulfam",
      z13: "geschwärzt",
      z14: "gewachst",
      z15: "gentechnisch"
    }, W = Fe(() => {
      if (!E.value || !E.value.substances)
        return "";
      const g = [];
      for (const x in E.value.substances)
        E.value.substances[x] && oe[x] && g.push(oe[x]);
      return g.join(", ");
    }), be = Fe(() => {
      if (!E.value) return 0;
      const g = E.value.sizes && E.value.sizes.length > 0, x = te.value.length > 0;
      if (g && x) {
        let b = 1 / 0;
        return te.value.forEach((T) => {
          T.options.forEach((H) => {
            H && typeof H.cost == "number" && (b = Math.min(b, H.cost));
          });
        }), b === 1 / 0 ? 0 : b;
      } else {
        if (g)
          return Math.min(...E.value.sizes.map((b) => b.price));
        if (x) {
          let b = 1 / 0;
          return te.value.forEach((T) => {
            T.options.forEach((H) => {
              H && typeof H.cost == "number" && (b = Math.min(b, H.cost));
            });
          }), b === 1 / 0 ? 0 : b;
        }
      }
      return 0;
    }), A = Fe(() => E.value ? !!(E.value.sizes && E.value.sizes.length > 1 || te.value.length > 0) : !1), ie = (g) => {
      if (!g)
        return "";
      const x = [];
      for (const b in g)
        g[b] && oe[b] && x.push(oe[b]);
      return x.join(", ");
    }, De = () => {
      p.value++;
    }, pe = () => {
      p.value > 1 && p.value--;
    }, ve = (g) => {
      d.value = g;
    }, je = Fe(() => {
      let g = 0, x = !1;
      for (const T of te.value) {
        const H = a[T.title] || [];
        if (H.length > 0) {
          const se = H[0], Z = T.options.find((c) => c && c.id === se);
          if (Z && typeof Z.cost == "number") {
            g = Z.cost, x = !0;
            break;
          }
        }
      }
      if (!x && E.value && E.value.sizes && E.value.sizes.length > 0) {
        const T = E.value.sizes.find((H) => H.vol === d.value);
        g = T ? T.price : E.value.sizes[0].price;
      }
      let b = 0;
      return E.value && E.value.extras && E.value.extras.variants && E.value.extras.variants.forEach((T) => {
        if (T.replaceArticle !== !0) {
          const H = a[T.title] || [];
          if (H.length > 0) {
            const se = H.map((Z) => T.options.find((c) => c && c.id === Z)).filter((Z) => Z && typeof Z.cost == "number" && Z.cost > 0);
            if (T.multi && T.freeArticles && T.freeArticles > 0) {
              se.sort((Z, c) => c.cost - Z.cost);
              for (let Z = T.freeArticles; Z < se.length; Z++)
                b += se[Z].cost;
            } else
              se.forEach((Z) => {
                b += Z.cost;
              });
          }
        }
      }), (g + b) * p.value;
    }), Ke = () => {
      if (E.value && E.value.extras && E.value.extras.variants) {
        for (const x of te.value)
          if (!x.multi && !x.optional && (a[x.title] || []).length === 0) {
            i("Auswahl erforderlich", `Bitte wähle eine Option aus bei "${x.title}"`, !0);
            return;
          }
        for (const x of q.value)
          if (He(x) && !x.multi && !x.optional && (a[x.title] || []).length === 0) {
            i("Auswahl erforderlich", `Bitte wähle eine Option aus bei "${x.title}"`, !0);
            return;
          }
      }
      const g = da({
        article: E.value,
        selectedVariants: a,
        selectedSize: d.value,
        quantity: p.value,
        itemType: l.itemType,
        totalPrice: je.value
      });
      console.log("Adding to cart:", g), o("add-to-cart", JSON.stringify(g));
    }, Te = (g) => {
      const x = f.value.indexOf(g);
      x > -1 ? f.value.splice(x, 1) : f.value.push(g);
    }, we = (g, x) => (a[g.title] || []).includes(x), Bt = (g, x) => {
      let b = a[g.title] || [];
      const T = g.implicit && !g.optional && m(g).length === 1;
      if (b.includes(x)) {
        if (T && b.length === 1) {
          i("Auswahl erforderlich", `Diese Option muss bei "${g.title}" ausgewählt bleiben.`, !0);
          return;
        }
        a[g.title] = b.filter((H) => H !== x);
      } else if (!g.multi)
        a[g.title] = [x];
      else {
        if (g.maxOptions && b.length >= g.maxOptions) {
          i("Auswahlbegrenzung erreicht", `Du kannst maximal ${g.maxOptions} Optionen bei "${g.title}" auswählen.`, !0);
          return;
        }
        a[g.title] = [...b, x];
      }
    }, He = (g) => {
      if (!g.trigger)
        return !0;
      const x = g.trigger;
      for (const b in a)
        if ((a[b] || []).includes(x))
          return !0;
      return !1;
    }, ge = (g) => {
      const x = [];
      return (g.multi || g.optional) && x.push("Optional"), g.freeArticles && g.freeArticles > 0 && x.push(`${g.freeArticles} Optionen inbegriffen`), g.maxOptions && g.maxOptions > 0 && x.push(`Wähle bis zu ${g.maxOptions} Optionen`), x.join(", ");
    }, L = () => {
      o("close-additionals");
    }, z = () => {
      E.value && E.value.image && o("click-image", E.value.image);
    };
    function Ae(g) {
      let x = 0, b = 0, T = 0;
      return g.length === 4 ? (x = parseInt(g[1] + g[1], 16), b = parseInt(g[2] + g[2], 16), T = parseInt(g[3] + g[3], 16)) : g.length === 7 && (x = parseInt(g.substring(1, 3), 16), b = parseInt(g.substring(3, 5), 16), T = parseInt(g.substring(5, 7), 16)), { r: x, g: b, b: T };
    }
    function It(g) {
      const x = g.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/) || g.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
      return x ? {
        r: parseInt(x[1]),
        g: parseInt(x[2]),
        b: parseInt(x[3])
      } : null;
    }
    const pt = (g) => {
      let x, b, T;
      if (g.startsWith("#")) {
        const se = Ae(g);
        x = se.r, b = se.g, T = se.b;
      } else if (g.startsWith("rgb")) {
        const se = It(g);
        if (se)
          x = se.r, b = se.g, T = se.b;
        else
          return "white";
      } else
        return "white";
      return (0.299 * x + 0.587 * b + 0.114 * T) / 255 > 0.5 ? "black" : "white";
    };
    function ht(g, x) {
      let b, T, H;
      if (g.startsWith("#")) {
        const Z = Ae(g);
        b = Z.r, T = Z.g, H = Z.b;
      } else if (g.startsWith("rgb")) {
        const Z = It(g);
        if (Z)
          b = Z.r, T = Z.g, H = Z.b;
        else
          return g;
      } else
        return g;
      const se = 1 + x;
      return b = Math.min(255, Math.floor(b * se)), T = Math.min(255, Math.floor(T * se)), H = Math.min(255, Math.floor(H * se)), `rgb(${b}, ${T}, ${H})`;
    }
    const Le = Fe(() => pt(l.primaryColor)), gt = Fe(() => ht(l.primaryColor, 0.2)), qe = Fe(() => pt(gt.value));
    return Lt(() => l.itemType, (g) => {
      g && typeof g == "string" && g.trim() !== "" ? console.log("itemType", g) : console.warn("Received empty or invalid itemType prop");
    }, { immediate: !0 }), (g, x) => (K(), X(le, null, [
      M("div", ha, [
        M("div", ga, [
          M("div", ma, [
            M("button", {
              onClick: L,
              class: "absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 transition-colors duration-200"
            }, x[1] || (x[1] = [
              M("svg", {
                class: "w-6 h-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                M("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ])),
            M("div", ba, [
              E.value.image ? (K(), X("div", va, [
                M("img", {
                  src: E.value.image,
                  alt: E.value.nameDE,
                  class: "w-full h-full object-cover rounded-xl shadow-lg border border-gray-200 cursor-pointer",
                  onClick: z
                }, null, 8, _a)
              ])) : me("", !0),
              M("div", ya, [
                M("h2", wa, ce(E.value.nameDE), 1),
                M("div", {
                  class: "description text-gray-600 mt-2",
                  innerHTML: E.value.descriptionDE
                }, null, 8, Ea),
                W.value ? (K(), X("div", xa, [
                  x[2] || (x[2] = M("span", { class: "font-semibold" }, "Enthält:", -1)),
                  Ln(" " + ce(W.value), 1)
                ])) : me("", !0),
                be.value > 0 ? (K(), X("div", Na, [
                  A.value ? (K(), X("span", Oa, "ab")) : me("", !0),
                  M("span", {
                    class: vt([{ "text-red-500": E.value.streichPreis > 0 }, "text-2xl font-bold text-gray-800"])
                  }, ce(be.value.toFixed(2)) + "€ ", 3),
                  E.value.streichPreis > 0 ? (K(), X("span", Da, ce(E.value.streichPreis.toFixed(2)) + "€ ", 1)) : me("", !0)
                ])) : me("", !0)
              ])
            ]),
            E.value.sizes && E.value.sizes.length > 1 ? (K(), X("div", Va, [
              x[3] || (x[3] = M("h3", { class: "text-lg font-semibold text-gray-700 mb-3" }, "Größe wählen:", -1)),
              M("div", Sa, [
                (K(!0), X(le, null, Gt(E.value.sizes, (b) => (K(), X("button", {
                  key: b.vol,
                  onClick: (T) => ve(b.vol),
                  class: vt(["size-option p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center", {
                    "hover:bg-gray-50": d.value !== b.vol
                  }]),
                  style: _e(d.value === b.vol ? { backgroundColor: gt.value, borderColor: l.primaryColor, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { borderColor: "#cbd5e1" })
                }, [
                  M("span", {
                    class: "text-lg font-medium",
                    style: _e(d.value === b.vol ? { color: qe.value } : {})
                  }, ce(b.vol), 5),
                  M("span", {
                    class: "text-md font-semibold mt-1",
                    style: _e(d.value === b.vol ? { color: qe.value } : {})
                  }, ce(b.price.toFixed(2)) + "€", 5)
                ], 14, Ca))), 128))
              ])
            ])) : me("", !0),
            te.value.length > 0 ? (K(), X("div", Ta, [
              (K(!0), X(le, null, Gt(te.value, (b) => (K(), X(le, {
                key: b.title
              }, [
                M("h3", Aa, ce(b.title), 1),
                M("div", Ia, [
                  (K(!0), X(le, null, Gt(m(b), (T) => (K(), X("button", {
                    key: T.id,
                    onClick: (H) => Bt(b, T.id),
                    class: vt(["size-option p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center", {
                      "hover:bg-gray-50": !we(b, T.id)
                    }]),
                    style: _e(we(b, T.id) ? { backgroundColor: gt.value, borderColor: l.primaryColor, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { borderColor: "#cbd5e1" })
                  }, [
                    T.imageUrl ? (K(), X("img", {
                      key: 0,
                      src: T.imageUrl,
                      alt: T.labelDE,
                      class: "optionImage object-cover rounded-full mb-2 border border-gray-200 shadow-sm"
                    }, null, 8, Pa)) : me("", !0),
                    M("div", $a, [
                      M("span", {
                        class: "text-lg font-medium",
                        style: _e(we(b, T.id) ? { color: qe.value } : {})
                      }, ce(T.labelDE), 5),
                      T.cost > 0 ? (K(), X("span", {
                        key: 0,
                        class: "text-sm font-semibold",
                        style: _e(we(b, T.id) ? { color: qe.value } : {})
                      }, " +" + ce(T.cost.toFixed(2)) + "€ ", 5)) : me("", !0)
                    ]),
                    T.substances ? (K(), X("div", {
                      key: 1,
                      style: _e(we(b, T.id) ? { color: qe.value } : {})
                    }, ce(ie(T.substances)), 5)) : me("", !0)
                  ], 14, ka))), 128))
                ])
              ], 64))), 128))
            ])) : me("", !0)
          ])
        ]),
        M("div", Ma, [
          M("div", Ra, [
            q.value.length > 0 ? (K(), X("div", ja, [
              (K(!0), X(le, null, Gt(q.value, (b) => (K(), X(le, {
                key: b.title
              }, [
                m(b).length > 0 && He(b) ? (K(), X("div", Fa, [
                  M("button", {
                    onClick: (T) => Te(b.title),
                    class: "accordion-header w-full flex justify-between items-center p-4 text-lg font-semibold text-left text-gray-700 bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                  }, [
                    M("div", Ha, [
                      M("span", null, ce(b.title), 1),
                      ge(b) ? (K(), X("span", La, ce(ge(b)), 1)) : me("", !0)
                    ]),
                    (K(), X("svg", {
                      class: vt(["w-5 h-5 transform transition-transform duration-200", { "rotate-180": f.value.includes(b.title) }]),
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, x[4] || (x[4] = [
                      M("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 9l-7 7-7-7"
                      }, null, -1)
                    ]), 2))
                  ], 8, za),
                  al(M("div", Ua, [
                    M("div", Ba, [
                      (K(!0), X(le, null, Gt(m(b), (T) => (K(), X("div", {
                        key: T.id,
                        onClick: (H) => Bt(b, T.id),
                        class: vt(["option-item p-4 border rounded-xl cursor-pointer transition-all duration-200 ease-in-out flex flex-col items-center justify-center text-center", {
                          "hover:bg-gray-50": !we(b, T.id)
                        }]),
                        style: _e(we(b, T.id) ? { backgroundColor: gt.value, borderColor: l.primaryColor, boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" } : { borderColor: "#cbd5e1" })
                      }, [
                        T.imageUrl ? (K(), X("img", {
                          key: 0,
                          src: T.imageUrl,
                          alt: T.labelDE,
                          class: "optionImage object-cover rounded-full mb-2 border border-gray-200 shadow-sm"
                        }, null, 8, Ka)) : me("", !0),
                        M("div", qa, [
                          M("span", {
                            class: "text-lg font-medium",
                            style: _e(we(b, T.id) ? { color: qe.value } : {})
                          }, ce(T.labelDE), 5),
                          T.cost > 0 ? (K(), X("span", {
                            key: 0,
                            class: "text-sm font-semibold",
                            style: _e(we(b, T.id) ? { color: qe.value } : {})
                          }, " +" + ce(T.cost.toFixed(2)) + "€ ", 5)) : me("", !0)
                        ]),
                        T.substances ? (K(), X("div", {
                          key: 1,
                          style: _e(we(b, T.id) ? { color: qe.value } : {})
                        }, ce(ie(T.substances)), 5)) : me("", !0)
                      ], 14, Wa))), 128))
                    ])
                  ], 512), [
                    [Jn, f.value.includes(b.title)]
                  ])
                ])) : me("", !0)
              ], 64))), 128))
            ])) : me("", !0)
          ])
        ]),
        M("div", Ga, [
          M("div", Ja, [
            M("div", Ya, [
              M("button", {
                onClick: pe,
                class: "quantity-button decrement",
                style: { "padding-bottom": "4px" }
              }, "- "),
              M("span", Xa, ce(p.value), 1),
              M("button", {
                onClick: De,
                class: "quantity-button increment",
                style: _e([{ "padding-bottom": "4px" }, { backgroundColor: l.primaryColor, color: Le.value }])
              }, "+ ", 4)
            ]),
            M("button", {
              onClick: Ke,
              class: "add-to-cart-button ml-10",
              style: _e({ backgroundColor: l.primaryColor, color: Le.value })
            }, " In den Korb (" + ce(je.value.toFixed(2)) + "€) ", 5)
          ])
        ])
      ]),
      Re(fa, null, {
        default: dn(() => [
          Re(ua, {
            title: r.value,
            message: n.value,
            modelValue: s.value,
            "onUpdate:modelValue": x[0] || (x[0] = (b) => s.value = b)
          }, null, 8, ["title", "message", "modelValue"])
        ]),
        _: 1
      })
    ], 64));
  }
}, Za = /* @__PURE__ */ na(Qa, [["styles", [pa]]]), eu = /* @__PURE__ */ Yc(Za);
customElements.define("item-additionals", eu);
